import { EmployeeAvatarType, ThemeProvider, Modal, ModalBody, ModalHeader, Padding, Text, Spacing, SelectInput, ThemeType, Box, Flexbox, Badge, MenuItemType, usePopover, EmployeeAvatar, Portal, Tether, PopoverAnimation, Menu2, fontFamilies, fontSizes, Stack, colors, IconSearch2, CircleSpinnerInline, IconClose, IconLock, Alert, useDebouncedCallback, EmployeesRow, FeaturedCard, DefinitionList, zIndices, useOnClickOutside, useKeyEvent, Tooltip, IconBug, IconNotFound, IconNotAllowed, IconNetworkLost, Button, Arrow, TextLink, IconExternal, Popper, IconButton, TileLink, IconExternal2, CircleSpinner } from '@newfront-insurance/core-ui';
import { useRouter } from '@newfront-insurance/next-router-provider';
import { createProvider, useProvider } from '@newfront-insurance/react-provision';
import React, { useState, useMemo, createContext, useContext, useEffect, useRef, forwardRef, useCallback, Suspense } from 'react';
import styled, { css } from 'styled-components';
import { AuthRole } from '@newfront-insurance/auth-api';
import { hasScope, hasAnyScope } from '@newfront-insurance/next-auth';
import { useHoverIntent } from 'react-use-hoverintent';
import { AccountStatus } from '@newfront-insurance/account-api';
import { useNextApiSubscription, useNextApiFetch } from '@newfront-insurance/next-api-swr';
import { r as routes } from './format-account-f3e79b24.esm.js';
import { toMap, isNotNil } from '@newfront-insurance/core';
import { PolicyStatus } from '@newfront-insurance/coverage-api';
import { u as usePolicy } from './use-policy-1760ed5d.esm.js';
import './trpc-2b4d7b2f.esm.js';
import { DateFormatStyle } from '@newfront-insurance/string-formatters';
import _extends from '@babel/runtime/helpers/esm/extends';
import './line-of-coverage-851873c4.esm.js';
import '@newfront-insurance/dsl-schema-ui';
import 'formik';
import '@newfront-insurance/next-notifications';
import 'react-use';
import '@newfront-insurance/core-money';
import 'pluralize';
import 'yup';
import '@newfront-insurance/spreadsheet';
import '@newfront-insurance/spreadsheet/dist/src/components/table/popover';
import 'lodash/find';
import 'lodash/get';
import 'lodash/uniqBy';
import './schemas-21e94256.esm.js';
import '@newfront-insurance/users-api';
import 'tiny-invariant';
import 'fuse.js';
import 'lodash.noop';
import 'smartystreets-javascript-sdk';
import './smarty-street-public-key-85081a7e.esm.js';
import '@newfront-insurance/account-common';
import { useGoogleToken } from '@newfront-insurance/next-gapi';
import useSWR from 'swr';
import urlcat from 'urlcat';
import { getPreferredErrorMessage, isTRPCClientError, isPermissionError, isTimeoutError, isNetworkError, isNotFoundError, isNotLoggedInError } from '@newfront-insurance/data-layer-client';
import { ErrorBoundary } from 'react-error-boundary';

/**
 * This is used internally to access the layout config.
 * @access private
 */
const LayoutConfigProvider = createProvider(props => props);

/**
 * Returns the avatar type based on the auth role. Because a user can have multiple roles we don't
 * want to use a map for this so that we can prioritise the return value.
 */

function useAuthAvatarType() {
  const {
    authProvider
  } = useProvider(LayoutConfigProvider);
  const {
    userDetails: user
  } = useProvider(authProvider);
  const isProducer = hasScope((user === null || user === void 0 ? void 0 : user.scopes) ?? [], AuthRole.PRODUCER);
  const isEngineer = hasScope((user === null || user === void 0 ? void 0 : user.scopes) ?? [], AuthRole.ENGINEER);
  const isAccountManager = hasScope((user === null || user === void 0 ? void 0 : user.scopes) ?? [], AuthRole.ACCOUNT_MANAGER);
  const isOperations = hasScope((user === null || user === void 0 ? void 0 : user.scopes) ?? [], AuthRole.OPERATIONS);

  if (isEngineer) {
    return undefined;
  }

  if (isProducer) {
    return EmployeeAvatarType.Producer;
  }

  if (isAccountManager) {
    return EmployeeAvatarType.AccountManager;
  }

  if (isOperations) {
    return EmployeeAvatarType.CustomerService;
  }

  return undefined;
}
/**
 * Get the image url for the current logged in user
 */

function useAuthProfilePic() {
  const {
    authProvider
  } = useProvider(LayoutConfigProvider);
  const {
    userDetails: user
  } = useProvider(authProvider);
  return user === null || user === void 0 ? void 0 : user.profilePic;
}

/* eslint-disable max-len */
function FeaturePreviewModal(props) {
  const {
    onClose,
    isOpen
  } = props;
  const {
    setTheme,
    name: themeName
  } = useProvider(ThemeProvider);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onToggle: onClose
  }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(ModalHeader, {
    titleText: "Experimental features",
    onClose: onClose
  }), /*#__PURE__*/React.createElement(Padding, {
    size: 24
  }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement("p", null, "You can enable these to get an early look at upcoming features. These features are likely to change and have missing functionality and have access to dark mode."), /*#__PURE__*/React.createElement("p", null, "Give the team feedback on these features in Slack in the", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://newfront.slack.com/archives/CPM6JUMCN",
    target: "_blank",
    rel: "noreferrer"
  }, "#ask-bugs"), ' ', "channel.")), /*#__PURE__*/React.createElement(Spacing, {
    height: 24
  }), /*#__PURE__*/React.createElement(FeatureRow, {
    title: "Appearance",
    description: "When you enable this feature you\u2018ll be able to change the theme of the dashboard."
  }, /*#__PURE__*/React.createElement(SelectInput, {
    value: themeName,
    width: "200px",
    onChange: theme => {
      setTheme(theme);
    },
    options: [{
      label: 'Light (Default)',
      value: ThemeType.LIGHT
    }, {
      label: 'Dark',
      value: ThemeType.DARK
    }, {
      label: 'Automatic',
      value: ThemeType.SYSTEM
    }]
  })))));
}

function FeatureRow(props) {
  const {
    description,
    title,
    children
  } = props;
  return /*#__PURE__*/React.createElement(Box, {
    border: 1,
    borderRadius: 4
  }, /*#__PURE__*/React.createElement(Box, {
    borderBottom: 1
  }, /*#__PURE__*/React.createElement(Padding, {
    size: 16
  }, /*#__PURE__*/React.createElement(Flexbox, {
    flexDirection: "row",
    gap: 16,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: '1'
    }
  }, /*#__PURE__*/React.createElement(Flexbox, {
    flexDirection: "row",
    gap: 8,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement("strong", null, title)), /*#__PURE__*/React.createElement(Badge, {
    type: "warning"
  }, "Experimental"))), children))), /*#__PURE__*/React.createElement(Padding, {
    size: 16
  }, /*#__PURE__*/React.createElement(Text, null, description)));
}

/**
 * Render the account menu popover items that is used in the global navigation based on the type
 * of user that is currently logged in. Returns an array of MenuItems that can be used with the Menu component.
 */
function useAccountMenuItems(_ref) {
  let {
    onFeaturePreview
  } = _ref;
  const {
    authProvider,
    logoutRedirect,
    legacyAppBaseUrl
  } = useProvider(LayoutConfigProvider);
  const {
    logout,
    userDetails: user
  } = useProvider(authProvider);
  const isProducer = user === null || user === void 0 ? void 0 : user.scopes.includes(AuthRole.PRODUCER);
  const isEngineer = user === null || user === void 0 ? void 0 : user.scopes.includes(AuthRole.ENGINEER);

  function onLogout() {
    return logout(logoutRedirect);
  }

  const menuItems = [];

  if (isProducer) {
    menuItems.push({
      type: MenuItemType.TITLE,
      title: 'Legacy dashboard'
    }, {
      type: MenuItemType.LINK,
      label: 'View BORs',
      href: `${legacyAppBaseUrl}/admin/producer-dashboard?tab=BORs`,
      target: '_blank'
    }, {
      type: MenuItemType.LINK,
      label: 'View servicing requests',
      href: `${legacyAppBaseUrl}/admin/producer-dashboard?tab=Requests`,
      target: '_blank'
    }, {
      type: MenuItemType.DIVIDER
    }, {
      type: MenuItemType.TITLE,
      title: 'External links'
    }, {
      type: MenuItemType.LINK,
      label: 'View oracle',
      href: 'https://newfront.zendesk.com',
      target: '_blank'
    }, {
      type: MenuItemType.LINK,
      label: 'View market access',
      href: // eslint-disable-next-line max-len
      'https://10ay.online.tableau.com/#/site/newfrontinsurance/views/CarrierRiskAppetiteCatalog/CarrierRiskAppetite?:iid=1',
      target: '_blank'
    }, {
      type: MenuItemType.LINK,
      label: 'View your commission reports',
      href: 'https://app.captivateiq.com/login?next=/',
      target: '_blank'
    }, {
      type: MenuItemType.LINK,
      label: 'View your book’s key metrics',
      href: 'https://10ay.online.tableau.com/#/site/newfrontinsurance/views/ProducerKeyMetrics/KeyMetrics?:iid=1',
      target: '_blank'
    }, {
      type: MenuItemType.DIVIDER
    });
  }

  if (isEngineer) {
    menuItems.push({
      type: MenuItemType.LINK,
      label: 'Experimental features',
      onClick: onFeaturePreview
    }, {
      type: MenuItemType.DIVIDER
    });
  }

  menuItems.push({
    type: MenuItemType.LINK,
    label: 'Log out',
    onClick: onLogout
  });
  return menuItems;
}

function AccountMenu() {
  const employeeType = useAuthAvatarType();
  const imageUrl = useAuthProfilePic();
  const [showFeaturePreviewModal, setFeaturePreviewModal] = useState(false);
  const {
    popoverRef,
    isPopoverOpen,
    togglePopover,
    targetRef
  } = usePopover({
    excludeTarget: true
  });
  const menuItems = useAccountMenuItems({
    onFeaturePreview: () => {
      setFeaturePreviewModal(true);
      togglePopover();
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmployeeAvatar, {
    employeeType: employeeType,
    imageUrl: imageUrl,
    sizeInPixels: 32,
    onClick: togglePopover,
    ref: targetRef
  }), /*#__PURE__*/React.createElement(Portal, {
    name: "popover"
  }, /*#__PURE__*/React.createElement(Tether, {
    targetRef: targetRef,
    targetAnchor: "bottomRight",
    anchor: "topRight",
    yOffset: 10,
    xOffset: 0
  }, /*#__PURE__*/React.createElement(PopoverAnimation, {
    isOpen: isPopoverOpen,
    direction: "up"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "white",
    borderRadius: 3,
    elementRef: popoverRef,
    boxShadow: "overlay",
    style: {
      minWidth: 200
    }
  }, /*#__PURE__*/React.createElement(Padding, {
    y: 8
  }, /*#__PURE__*/React.createElement(Menu2, {
    items: menuItems
  })))))), /*#__PURE__*/React.createElement(FeaturePreviewModal, {
    onClose: () => setFeaturePreviewModal(false),
    isOpen: showFeaturePreviewModal
  }));
}

/* eslint-disable max-len */
const Container$1 = styled.div`
  border-radius: 4px;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.07);

  & svg {
    display: block;
  }
`;
function GrowthIcon(_ref) {
  let {
    size = 32
  } = _ref;
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "4",
    fill: "url(#paint0_linear_627:20825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 23H9C8.73478 23 8.48043 22.8946 8.29289 22.7071C8.10536 22.5196 8 22.2652 8 22V9H10V21H24V23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20H11V18C13.912 18 14.889 16.241 16.126 14.015C17.432 11.664 18.912 9 23 9H24V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_627:20825",
    x1: "16",
    y1: "0",
    x2: "16",
    y2: "32",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DB0E63"
  })))));
}
function AccountsIcon(_ref2) {
  let {
    size = 32
  } = _ref2;
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "4",
    fill: "url(#paint0_linear_627:20837)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_627:20837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6.3999C10.7064 6.3999 6.40002 10.7063 6.40002 15.9999C6.40002 21.2935 10.7064 25.5999 16 25.5999C21.2936 25.5999 25.6 21.2935 25.6 15.9999C25.6 10.7063 21.2936 6.3999 16 6.3999ZM12.8 14.3999C12.8 12.6327 14.2752 11.1999 16 11.1999C17.7248 11.1999 19.2 12.6327 19.2 14.3999V15.1999C19.2 16.9671 17.7248 18.3999 16 18.3999C14.2752 18.3999 12.8 16.9671 12.8 15.1999V14.3999ZM16 23.9999C14.0536 23.9999 12.268 23.2991 10.8792 22.1391C11.5504 20.8727 12.8664 19.9999 14.4 19.9999H17.6C19.1336 19.9999 20.4496 20.8727 21.1208 22.1391C19.732 23.2991 17.9464 23.9999 16 23.9999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_627:20837",
    x: "6.40002",
    y: "6.3999",
    width: "19.2",
    height: "21.2",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_627:20837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_627:20837",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_627:20837",
    x1: "16",
    y1: "0",
    x2: "16",
    y2: "32",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DB0E63"
  })))));
}
function ExposuresIcon(_ref3) {
  let {
    size = 32
  } = _ref3;
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "4",
    fill: "url(#paint0_linear_627:20849)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_627:20849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5C13.15 14.5 10.225 13.975 8.5 12.7V16C8.5 18.025 12.4 18.9999 16 18.9999C19.6 18.9999 23.5 18.025 23.5 16V12.7C21.775 13.975 18.85 14.5 16 14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5C13.15 20.5 10.225 19.975 8.5 18.7V21.9999C8.5 24.0249 12.4 24.9999 16 24.9999C19.6 24.9999 23.5 24.0249 23.5 21.9999V18.7C21.775 19.975 18.85 20.5 16 20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7C12.4 7 8.5 7.975 8.5 10C8.5 12.025 12.4 13 16 13C19.6 13 23.5 12.025 23.5 10C23.5 7.975 19.6 7 16 7Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_627:20849",
    x: "8.5",
    y: "7",
    width: "15",
    height: "20",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_627:20849"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_627:20849",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_627:20849",
    x1: "16",
    y1: "0",
    x2: "16",
    y2: "32",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DB0E63"
  })))));
}
function ClaimsIcon(_ref4) {
  let {
    size = 32
  } = _ref4;
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "4",
    fill: "url(#paint0_linear_627:20861)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_627:20861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.57 11V11.9167C14.8864 11.9497 14.2279 12.1852 13.6784 12.5933C13.4627 12.7621 13.2892 12.9787 13.1715 13.226C13.0538 13.4733 12.9951 13.7445 13 14.0183C12.9839 14.5158 13.1593 15.0005 13.49 15.3725C13.9669 15.8304 14.5396 16.1766 15.1667 16.3858L15.5675 16.5408V18.3942C15.1253 18.3599 14.6876 18.2818 14.2609 18.1608C13.8306 18.0498 13.412 17.8977 13.0109 17.7067V19.2842C13.8211 19.6235 14.6908 19.7982 15.5692 19.7983V21H16.3875V19.775C17.0847 19.7467 17.7565 19.5056 18.3125 19.0842C18.5366 18.8993 18.7151 18.6654 18.8343 18.4005C18.9535 18.1357 19.0102 17.8469 19 17.5567C19.0061 17.2357 18.9255 16.919 18.7667 16.64C18.584 16.3471 18.3369 16.0997 18.0442 15.9167C17.5185 15.603 16.9626 15.3429 16.385 15.14V13.3733C17.044 13.4298 17.6904 13.5869 18.3017 13.8392L18.8634 12.4408C18.0804 12.1033 17.2406 11.9167 16.3884 11.8908V11H15.57ZM15.57 14.8017C15.3561 14.7174 15.1572 14.5992 14.9809 14.4517C14.9211 14.3968 14.8739 14.3297 14.8424 14.2549C14.8109 14.1801 14.7959 14.0994 14.7984 14.0183C14.7984 13.68 15.0556 13.4728 15.57 13.3967V14.8017ZM16.3884 16.8633C16.6069 16.9552 16.8121 17.076 16.9984 17.2225C17.0622 17.2732 17.1136 17.3377 17.1488 17.4112C17.184 17.4847 17.2021 17.5652 17.2017 17.6467C17.2017 18.025 16.9306 18.26 16.3884 18.3517V16.8633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6C13.8352 5.998 11.7287 6.70191 10 8.005L8.5 6L6.5 11.6667L12.5 11.3333L11 9.3375C12.5012 8.2122 14.3383 7.62668 16.2138 7.67577C18.0893 7.72487 19.8933 8.40572 21.3335 9.60802C22.7738 10.8103 23.7659 12.4637 24.1493 14.3002C24.5326 16.1368 24.2847 18.0489 23.4457 19.727C22.6066 21.4051 21.2256 22.7507 19.5264 23.546C17.8272 24.3412 15.9092 24.5395 14.0832 24.1087C12.2572 23.6779 10.6301 22.6432 9.46557 21.1723C8.301 19.7013 7.66714 17.8803 7.66667 16.0042C7.66667 15.7832 7.57887 15.5712 7.42259 15.4149C7.26631 15.2586 7.05435 15.1708 6.83333 15.1708C6.61232 15.1708 6.40036 15.2586 6.24408 15.4149C6.0878 15.5712 6 15.7832 6 16.0042C6.00082 17.9818 6.58801 19.9148 7.68733 21.5587C8.78664 23.2027 10.3487 24.4838 12.1761 25.24C14.0034 25.9962 16.0139 26.1937 17.9535 25.8073C19.893 25.421 21.6744 24.4683 23.0725 23.0696C24.4706 21.6709 25.4226 19.8891 25.8082 17.9494C26.1937 16.0097 25.9954 13.9992 25.2384 12.1722C24.4814 10.3452 23.1997 8.78365 21.5553 7.68502C19.9109 6.58639 17.9776 6 16 6V6Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_627:20861",
    x: "6",
    y: "6",
    width: "20",
    height: "22",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_627:20861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_627:20861",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_627:20861",
    x1: "16",
    y1: "0",
    x2: "16",
    y2: "32",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DB0E63"
  })))));
}
function ConversionIcon(_ref5) {
  let {
    size = 32
  } = _ref5;
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    rx: "4",
    fill: "url(#paint0_linear_505_18529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 24.9999H15C13.6739 24.9999 12.4021 24.4731 11.4645 23.5354C10.5268 22.5977 10 21.3259 10 19.9999C10 18.6738 10.5268 17.402 11.4645 16.4643C12.4021 15.5266 13.6739 14.9999 15 14.9999V17.4999C14.9999 17.5935 15.0262 17.6853 15.0757 17.7647C15.1252 17.8442 15.1961 17.9081 15.2802 17.9493C15.3643 17.9905 15.4583 18.0072 15.5514 17.9976C15.6445 17.9879 15.7331 17.9524 15.807 17.8949L20.307 14.3949C20.3672 14.3481 20.416 14.2882 20.4495 14.2198C20.483 14.1513 20.5004 14.0761 20.5004 13.9999C20.5004 13.9236 20.483 13.8484 20.4495 13.7799C20.416 13.7115 20.3672 13.6516 20.307 13.6049L15.807 10.1049C15.7331 10.0474 15.6445 10.0118 15.5514 10.0022C15.4583 9.99254 15.3643 10.0093 15.2802 10.0504C15.1961 10.0916 15.1252 10.1555 15.0757 10.235C15.0262 10.3145 14.9999 10.4062 15 10.4999V12.9999C13.1435 12.9999 11.363 13.7374 10.0503 15.0501C8.7375 16.3629 8 18.1433 8 19.9999C8 21.8564 8.7375 23.6369 10.0503 24.9496C11.363 26.2624 13.1435 26.9999 15 26.9999H17C17.2652 26.9999 17.5196 26.8945 17.7071 26.707C17.8946 26.5194 18 26.2651 18 25.9999C18 25.7346 17.8946 25.4803 17.7071 25.2928C17.5196 25.1052 17.2652 24.9999 17 24.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0004 13H23.0004C22.7352 13 22.4809 13.1054 22.2933 13.2929C22.1058 13.4804 22.0004 13.7348 22.0004 14C22.0004 14.2652 22.1058 14.5196 22.2933 14.7071C22.4809 14.8946 22.7352 15 23.0004 15H25.0004C26.3265 15 27.5983 15.5268 28.536 16.4645C29.4737 17.4021 30.0004 18.6739 30.0004 20C30.0004 21.3261 29.4737 22.5979 28.536 23.5355C27.5983 24.4732 26.3265 25 25.0004 25V22.5C25.0005 22.4064 24.9743 22.3146 24.9247 22.2351C24.8752 22.1557 24.8044 22.0917 24.7203 22.0506C24.6362 22.0094 24.5422 21.9927 24.4491 22.0023C24.3559 22.0119 24.2674 22.0475 24.1934 22.105L19.6934 25.605C19.6332 25.6517 19.5845 25.7116 19.551 25.7801C19.5174 25.8485 19.5 25.9238 19.5 26C19.5 26.0762 19.5174 26.1515 19.551 26.2199C19.5845 26.2884 19.6332 26.3483 19.6934 26.395L24.1934 29.895C24.2674 29.9525 24.3559 29.9881 24.4491 29.9977C24.5422 30.0073 24.6362 29.9906 24.7203 29.9494C24.8044 29.9083 24.8752 29.8443 24.9247 29.7649C24.9743 29.6854 25.0005 29.5936 25.0004 29.5V27C26.857 27 28.6374 26.2625 29.9502 24.9497C31.2629 23.637 32.0004 21.8565 32.0004 20C32.0004 18.1435 31.2629 16.363 29.9502 15.0503C28.6374 13.7375 26.857 13 25.0004 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_505_18529",
    x1: "20",
    y1: "0",
    x2: "20",
    y2: "40",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DB0E63"
  })))));
}
function FilesIcon$1(_ref6) {
  let {
    size = 32
  } = _ref6;
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "4",
    fill: "url(#paint0_linear_628:21672)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_628:21672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1667 12.6666H10.1667C9.94565 12.6666 9.73369 12.7544 9.57741 12.9107C9.42113 13.0669 9.33333 13.2789 9.33333 13.4999V22.6666C9.33333 22.8876 9.24554 23.0996 9.08926 23.2558C8.93298 23.4121 8.72101 23.4999 8.5 23.4999C8.27899 23.4999 8.06702 23.4121 7.91074 23.2558C7.75446 23.0996 7.66667 22.8876 7.66667 22.6666V8.49992H11.3875L12.8042 10.6291C12.8805 10.7435 12.984 10.8373 13.1054 10.902C13.2269 10.9667 13.3624 11.0004 13.5 10.9999H21.8333V11.8333H23.5V10.1666C23.5 9.94558 23.4122 9.73361 23.2559 9.57733C23.0996 9.42105 22.8877 9.33326 22.6667 9.33326H13.9458L12.5292 7.20409C12.4528 7.08964 12.3493 6.99588 12.2279 6.93117C12.1065 6.86646 11.9709 6.83282 11.8333 6.83326H6.83333C6.61232 6.83326 6.40036 6.92105 6.24408 7.07733C6.0878 7.23361 6 7.44558 6 7.66659V22.6666C6.00242 23.3289 6.26658 23.9634 6.7349 24.4317C7.20322 24.9 7.8377 25.1642 8.5 25.1666H9.33333H23.5C24.1622 25.164 24.7966 24.8997 25.2649 24.4314C25.7331 23.9632 25.9974 23.3288 26 22.6666V13.4999C26 13.2789 25.9122 13.0669 25.7559 12.9107C25.5996 12.7544 25.3877 12.6666 25.1667 12.6666Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_628:21672",
    x: "6",
    y: "6.83325",
    width: "20",
    height: "20.3333",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_628:21672"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_628:21672",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_628:21672",
    x1: "16",
    y1: "0",
    x2: "16",
    y2: "32",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DB0E63"
  })))));
}
function QuotingIcon(_ref7) {
  let {
    size = 32
  } = _ref7;
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "4",
    fill: "url(#paint0_linear_719:22646)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_719:22646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.375 20.4249C16.225 20.4999 16.15 20.4999 16 20.4999C15.85 20.4999 15.775 20.4999 15.625 20.4249L7 15.7749V24.2499C7 24.6999 7.3 24.9999 7.75 24.9999H24.25C24.7 24.9999 25 24.6999 25 24.2499V15.7749L16.375 20.4249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.45V8.5H20.5V13V16.45L24.325 14.35L22 12.625V7.75C22 7.3 21.7 7 21.25 7H10.75C10.3 7 10 7.3 10 7.75V12.7L7.67505 14.425L11.5 16.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10.75H13V12.25H19V10.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 13.75H13V15.25H19V13.75Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_719:22646",
    x: "7",
    y: "7",
    width: "18",
    height: "20",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_719:22646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_719:22646",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719:22646",
    x1: "16",
    y1: "0",
    x2: "16",
    y2: "32",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DB0E63"
  })))));
}
function CertificatesIcon(_ref8) {
  let {
    size = 32
  } = _ref8;
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "4",
    fill: "url(#paint0_linear_719:22627)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_719:22627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.625 25H9.125C8.45 25 8 24.55 8 23.875V8.125C8 7.45 8.45 7 9.125 7H22.625V9.25H10.25V22.75H21.5V21.625H23.75V23.875C23.75 24.55 23.3 25 22.625 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 13.75C26 11.8375 24.5375 10.375 22.625 10.375C20.7125 10.375 19.25 11.8375 19.25 13.75C19.25 14.7625 19.7 15.6625 20.375 16.225V20.5L22.625 18.25L24.875 20.5V16.225C25.55 15.6625 26 14.7625 26 13.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.625H12.5V14.875H17V12.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 17.125H12.5V19.375H18.125V17.125Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_719:22627",
    x: "8",
    y: "7",
    width: "18",
    height: "20",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_719:22627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_719:22627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719:22627",
    x1: "16",
    y1: "0",
    x2: "16",
    y2: "32",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DB0E63"
  })))));
}
function TradingPartnersIcon(_ref9) {
  let {
    size = 32
  } = _ref9;
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    rx: "4",
    fill: "url(#paint0_linear_2_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4255 14.0994C24.4255 15.2731 23.9593 16.3987 23.1293 17.2287C22.2994 18.0586 21.1737 18.5249 20 18.5249C18.8263 18.5249 17.7006 18.0586 16.8707 17.2287C16.0407 16.3987 15.5745 15.2731 15.5745 14.0994C15.5745 12.9256 16.0407 11.8 16.8707 10.97C17.7006 10.1401 18.8263 9.67383 20 9.67383C21.1737 9.67383 22.2994 10.1401 23.1293 10.97C23.9593 11.8 24.4255 12.9256 24.4255 14.0994ZM31.8014 17.0497C31.8014 17.8322 31.4906 18.5826 30.9373 19.1359C30.384 19.6892 29.6335 20.0001 28.851 20.0001C28.0686 20.0001 27.3181 19.6892 26.7648 19.1359C26.2115 18.5826 25.9007 17.8322 25.9007 17.0497C25.9007 16.2672 26.2115 15.5168 26.7648 14.9635C27.3181 14.4102 28.0686 14.0994 28.851 14.0994C29.6335 14.0994 30.384 14.4102 30.9373 14.9635C31.4906 15.5168 31.8014 16.2672 31.8014 17.0497ZM25.9007 27.376C25.9007 25.811 25.279 24.3101 24.1724 23.2035C23.0658 22.0969 21.5649 21.4752 20 21.4752C18.435 21.4752 16.9341 22.0969 15.8276 23.2035C14.721 24.3101 14.0993 25.811 14.0993 27.376V31.8015H25.9007V27.376ZM14.0993 17.0497C14.0993 17.8322 13.7884 18.5826 13.2351 19.1359C12.6818 19.6892 11.9314 20.0001 11.1489 20.0001C10.3664 20.0001 9.616 19.6892 9.0627 19.1359C8.50941 18.5826 8.19857 17.8322 8.19857 17.0497C8.19857 16.2672 8.50941 15.5168 9.0627 14.9635C9.616 14.4102 10.3664 14.0994 11.1489 14.0994C11.9314 14.0994 12.6818 14.4102 13.2351 14.9635C13.7884 15.5168 14.0993 16.2672 14.0993 17.0497ZM28.851 31.8015V27.376C28.8532 25.8761 28.4724 24.4006 27.7447 23.0891C28.3987 22.9217 29.0823 22.9059 29.7433 23.0429C30.4044 23.18 31.0254 23.4661 31.559 23.8797C32.0926 24.2932 32.5247 24.8231 32.8224 25.429C33.1201 26.035 33.2754 26.7009 33.2766 27.376V31.8015H28.851ZM12.2553 23.0891C11.5277 24.4006 11.1469 25.8761 11.1489 27.376V31.8015H6.72339V27.376C6.7231 26.7004 6.87749 26.0337 7.17471 25.427C7.47194 24.8204 7.90411 24.2898 8.43811 23.876C8.97211 23.4622 9.59376 23.1761 10.2554 23.0397C10.9171 22.9033 11.6012 22.9202 12.2553 23.0891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_535",
    x1: "20",
    y1: "0",
    x2: "20",
    y2: "40",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DB0E63"
  })))));
}
function BillingIcon(_ref10) {
  let {
    size = 32
  } = _ref10;
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    rx: "4",
    fill: "url(#paint0_linear_324_14012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0335 23.7765V14.6276C28.0335 13.3696 27.0006 12.3403 25.7382 12.3403H9.67115C8.40874 12.3403 7.37585 13.3696 7.37585 14.6276V23.7765C7.37585 25.0345 8.40874 26.0637 9.67115 26.0637H25.7382C27.0006 26.0637 28.0335 25.0345 28.0335 23.7765ZM17.7047 22.6329C15.7996 22.6329 14.2617 21.1004 14.2617 19.202C14.2617 17.3036 15.7996 15.7712 17.7047 15.7712C19.6098 15.7712 21.1476 17.3036 21.1476 19.202C21.1476 21.1004 19.6098 22.6329 17.7047 22.6329ZM32.6241 15.7712V28.351C32.6241 29.6089 31.5912 30.6382 30.3288 30.6382H10.8188V28.351H30.3288V15.7712H32.6241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_324_14012",
    x1: "20",
    y1: "0",
    x2: "20",
    y2: "40",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DB0E63"
  })))));
}

let AppType;

(function (AppType) {
  AppType["ACCOUNTS"] = "ACCOUNTS";
  AppType["CERTIFICATES"] = "CERTIFICATES";
  AppType["CLAIMS"] = "CLAIMS";
  AppType["CONVERSION"] = "CONVERSION";
  AppType["EXPOSURES"] = "EXPOSURES";
  AppType["FILES"] = "FILES";
  AppType["PIPELINE"] = "PIPELINE";
  AppType["QUOTING"] = "QUOTING";
  AppType["TRADING_PARTNERS"] = "TRADING PARTNERS";
  AppType["BILLING"] = "BILLING";
})(AppType || (AppType = {}));

const APP_METADATA = {
  [AppType.ACCOUNTS]: {
    label: 'Accounts',
    description: 'View and manage your accounts',
    href: '/accounts',
    type: AppType.ACCOUNTS,
    icon: AccountsIcon,
    showInMenu: true,
    scopes: [AuthRole.ACCOUNT_MANAGER, AuthRole.AM_MANAGER, AuthRole.CSA, AuthRole.ENGINEER, AuthRole.GROWTH_CALLER, AuthRole.OPERATIONS, AuthRole.PRODUCER_MANAGER, AuthRole.PRODUCER, AuthRole.RISK_MANAGER, AuthRole.SALES_MANAGER]
  },
  [AppType.CERTIFICATES]: {
    label: 'Certificates',
    description: 'Generate and download certificates',
    href: '/growth',
    type: AppType.CERTIFICATES,
    icon: CertificatesIcon,
    showInMenu: false,
    scopes: [AuthRole.ACCOUNT_MANAGER, AuthRole.AM_MANAGER, AuthRole.CSA, AuthRole.ENGINEER, // AuthRole.GROWTH_CALLER,
    AuthRole.OPERATIONS // AuthRole.PRODUCER_MANAGER,
    // AuthRole.PRODUCER,
    // AuthRole.RISK_MANAGER,
    // AuthRole.SALES_MANAGER,
    ]
  },
  [AppType.CLAIMS]: {
    label: 'Claims',
    description: 'Track and manage claims',
    href: '/claims',
    type: AppType.CLAIMS,
    icon: ClaimsIcon,
    showInMenu: false,
    scopes: [AuthRole.ACCOUNT_MANAGER, AuthRole.AM_MANAGER, AuthRole.CSA, AuthRole.ENGINEER, // AuthRole.GROWTH_CALLER,
    AuthRole.OPERATIONS, // AuthRole.PRODUCER_MANAGER,
    // AuthRole.PRODUCER,
    AuthRole.RISK_MANAGER // AuthRole.SALES_MANAGER,
    ]
  },
  [AppType.CONVERSION]: {
    label: 'Conversion',
    description: 'Manage BORs and producer onboarding',
    href: '/conversion',
    type: AppType.CONVERSION,
    icon: ConversionIcon,
    showInMenu: false,
    scopes: [AuthRole.CONVERSION, AuthRole.ENGINEER]
  },
  [AppType.EXPOSURES]: {
    label: 'Exposures',
    description: 'View and edit exposure data',
    href: '/exposures',
    type: AppType.EXPOSURES,
    icon: ExposuresIcon,
    showInMenu: false,
    scopes: [AuthRole.ACCOUNT_MANAGER, AuthRole.AM_MANAGER, AuthRole.CSA, AuthRole.ENGINEER, // AuthRole.GROWTH_CALLER,
    AuthRole.OPERATIONS, AuthRole.PRODUCER_MANAGER, AuthRole.PRODUCER, AuthRole.RISK_MANAGER, AuthRole.SALES_MANAGER]
  },
  [AppType.FILES]: {
    label: 'Files',
    description: 'Manage file uploads and emails',
    href: '/files',
    type: AppType.FILES,
    icon: FilesIcon$1,
    showInMenu: false,
    scopes: [AuthRole.ACCOUNT_MANAGER, AuthRole.AM_MANAGER, AuthRole.CSA, AuthRole.ENGINEER, AuthRole.OPERATIONS, AuthRole.PRODUCER_MANAGER, AuthRole.PRODUCER, AuthRole.RISK_MANAGER, AuthRole.SALES_MANAGER]
  },
  [AppType.PIPELINE]: {
    label: 'Pipeline',
    description: 'Manage and track all of your opportunities',
    href: '/pipeline',
    type: AppType.PIPELINE,
    icon: GrowthIcon,
    showInMenu: true,
    scopes: [// AuthRole.ACCOUNT_MANAGER,
    // AuthRole.ADMIN_ACCOUNT_MANAGER,
    // AuthRole.CSA,
    AuthRole.ENGINEER, AuthRole.GROWTH_CALLER, // AuthRole.OPERATIONS,
    AuthRole.PRODUCER_MANAGER, AuthRole.PRODUCER, // AuthRole.RISK_MANAGER,
    AuthRole.SALES_MANAGER]
  },
  [AppType.QUOTING]: {
    label: 'Quoting',
    description: 'Manage submissions and create proposals',
    href: '/quoting',
    type: AppType.QUOTING,
    icon: QuotingIcon,
    showInMenu: false,
    scopes: [AuthRole.ACCOUNT_MANAGER, AuthRole.AM_MANAGER, AuthRole.CSA, AuthRole.ENGINEER, // AuthRole.GROWTH_CALLER,
    AuthRole.OPERATIONS, AuthRole.PRODUCER_MANAGER, AuthRole.PRODUCER // AuthRole.RISK_MANAGER,
    // AuthRole.SALES_MANAGER,
    ]
  },
  [AppType.TRADING_PARTNERS]: {
    label: 'Trading partners',
    description: 'Find trading partner and contact information',
    href: '/trading-partners/list',
    type: AppType.TRADING_PARTNERS,
    icon: TradingPartnersIcon,
    showInMenu: true,
    scopes: [AuthRole.ENGINEER, AuthRole.CARRIER_RELATIONS]
  },
  [AppType.BILLING]: {
    label: 'Billing',
    description: 'Manage invoices',
    href: '/billing',
    type: AppType.BILLING,
    icon: BillingIcon,
    showInMenu: true,
    scopes: [AuthRole.ACCOUNT_MANAGER, AuthRole.AM_MANAGER, AuthRole.CSA, AuthRole.ENGINEER, AuthRole.OPERATIONS, AuthRole.PRODUCER_MANAGER, AuthRole.PRODUCER, AuthRole.RISK_MANAGER, AuthRole.SALES_MANAGER]
  }
};
/**
 * Get all of the available app types.
 * @returns Array of app types
 */

function getAppTypes() {
  return Object.values(AppType);
}
/**
 * Returns the metadata for an app.
 * @param type AppType
 * @returns AppMetadata
 */

function getAppTypeMetadata(type) {
  const metadata = APP_METADATA[type];

  if (!metadata) {
    throw new Error(`Invalid app type: ${type}`);
  }

  return metadata;
}
/**
 * Determine if the user can access an app using their roles.
 * @param type AppType
 * @param userRoles Array of roles from the user object
 * @returns boolean
 */

function canViewApp(type, userRoles) {
  const {
    scopes
  } = getAppTypeMetadata(type);
  return hasAnyScope(userRoles, scopes);
}

function AppBadge(props) {
  const {
    type,
    iconSize = 32,
    textSize = 'small',
    showDescription = false
  } = props;
  const {
    label,
    icon: Icon,
    description
  } = getAppTypeMetadata(type);
  const textSizeValue = textSize === 'small' ? fontSizes.regular.fontSize : fontSizes.large.fontSize;
  const iconGapSize = iconSize === 40 ? 12 : 8;
  return /*#__PURE__*/React.createElement(Flexbox, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize
  }), /*#__PURE__*/React.createElement(Spacing, {
    width: iconGapSize
  }), /*#__PURE__*/React.createElement(Stack, {
    direction: "vertical",
    gap: showDescription ? 4 : 0,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Label, {
    style: {
      '--fontSize': textSizeValue
    }
  }, label), showDescription ? /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: colors.steel[400],
    style: {
      lineHeight: '12px'
    }
  }, description) : null));
}
const Label = styled.span`
  display: block;
  font-family: ${fontFamilies.body};
  font-weight: 600;
  font-size: var(--fontSize);
  line-height: 17px;
  color: #db0e63;
`;

const ToolbarButton = styled.a({
  height: 40,
  width: 40,
  textIndent: -9999,
  borderRadius: 40,
  color: colors.steel[400],
  transition: 'all 200ms ease-in-out',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover, &[data-active="true"]': {
    background: colors.steel[100],
    cursor: 'pointer'
  },
  '&:focus': {
    outline: 'none',
    background: colors.steel[100]
  }
});

function AppSwitcherMenu(props) {
  const {
    types
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, types.map(type => {
    const {
      href,
      label
    } = getAppTypeMetadata(type);
    return /*#__PURE__*/React.createElement(StyledMenuItem, {
      tabIndex: 0,
      title: label,
      role: "menuitem",
      href: href,
      key: href
    }, /*#__PURE__*/React.createElement(AppBadge, {
      type: type,
      iconSize: 32,
      textSize: "small",
      showDescription: true
    }));
  }));
}
const StyledMenuItem = styled.a`
  align-item: center;
  box-sizing: border-box;
  color: ${colors.steel[400]};
  cursor: pointer;
  display: flex;
  font-family: ${fontFamilies.body};
  font-size: ${fontSizes.regular.fontSize};
  margin: 4px 8px;
  padding: 8px;
  position: relative;
  text-decoration: none;
  white-space: nowrap;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px inset ${colors.brand[400]};
    color: ${colors.brand[400]};
    background: ${colors.brand[100]};
    text-decoration: none;
  }

  &.isSelected {
    color: ${colors.brand[400]};
  }

  &.isDisabled {
    color: ${colors.steel[200]};
    cursor: not-allowed;
    pointer-events: none;
  }

  &:not(.isDisabled):hover {
    color: ${colors.brand[400]};
    background: ${colors.brand[100]};
    text-decoration: none;
  }
`;

function AppSwitcherButton() {
  const {
    popoverRef,
    isPopoverOpen,
    togglePopover,
    targetRef
  } = usePopover({
    excludeTarget: true
  });
  const appTypes = useAppSwitcherItems(); // There are no other apps available

  if (appTypes.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToolbarButton, {
    tabIndex: 0,
    title: "Swtich app",
    "data-active": isPopoverOpen,
    onClick: togglePopover,
    ref: targetRef
  }, /*#__PURE__*/React.createElement(AppSwitcherIcon, null)), /*#__PURE__*/React.createElement(Portal, {
    name: "popover"
  }, /*#__PURE__*/React.createElement(Tether, {
    targetRef: targetRef,
    targetAnchor: "bottomRight",
    anchor: "topRight",
    yOffset: 10,
    xOffset: 0
  }, /*#__PURE__*/React.createElement(PopoverAnimation, {
    isOpen: isPopoverOpen,
    direction: "up"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "white",
    borderRadius: 3,
    elementRef: popoverRef,
    boxShadow: "overlay"
  }, /*#__PURE__*/React.createElement(Padding, {
    y: 8
  }, /*#__PURE__*/React.createElement(AppSwitcherMenu, {
    types: appTypes
  })))))));
}

function AppSwitcherIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M0 3.98671H3.84512V0H0V3.98671ZM5.76768 15.9468H9.61281V11.9601H5.76768V15.9468ZM0 15.9468H3.84512V11.9601H0V15.9468ZM0 9.96678H3.84512V5.98007H0V9.96678ZM5.76768 9.96678H9.61281V5.98007H5.76768V9.96678ZM11.5354 0V3.98671H15.3805V0H11.5354ZM5.76768 3.98671H9.61281V0H5.76768V3.98671ZM11.5354 9.96678H15.3805V5.98007H11.5354V9.96678ZM11.5354 15.9468H15.3805V11.9601H11.5354V15.9468Z",
    fill: "currentColor"
  }));
}

function useAppSwitcherItems() {
  const {
    authProvider,
    currentApp,
    isBillingAppEnabled = false
  } = useProvider(LayoutConfigProvider);
  const {
    userDetails: user
  } = useProvider(authProvider); // Get all of the app types and filter out the current app

  return useMemo(() => {
    return getAppTypes() // Don't show the current app
    .filter(type => type !== currentApp) // Filter app to ones set to show in menu
    .filter(type => {
      if (type === AppType.BILLING) {
        return isBillingAppEnabled;
      }

      const {
        showInMenu
      } = getAppTypeMetadata(type);
      return showInMenu;
    }) // Filter the apps shown using the scopes on the user.
    .filter(type => {
      if (!user) return false;
      return canViewApp(type, user.roles);
    }).sort();
  }, [currentApp, user, isBillingAppEnabled]);
}

/* eslint-disable @typescript-eslint/no-empty-function */
const SearchContext = /*#__PURE__*/createContext({
  activeResultIndex: 0,
  currentQuery: '',
  error: undefined,
  isSearching: false,
  recentlySearched: [],
  recentlyVisited: [],
  results: undefined,
  setActiveResultIndex: () => {},
  setIsSearchActive: () => {},
  suggestions: undefined
});

const ACTIVE_GLOBAL_SEARCH_KEY = '/';

function InputSearch(_ref) {
  let {
    innerRef,
    onChange,
    onReset,
    onKeyDown,
    placeholder
  } = _ref;
  const {
    currentQuery,
    isSearching,
    results,
    error
  } = useContext(SearchContext);

  const handleOnReset = () => {
    var _innerRef$current;

    innerRef === null || innerRef === void 0 ? void 0 : (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.focus();
    onReset();
  };

  return /*#__PURE__*/React.createElement(StyledInputSearch, {
    isResultActive: !!currentQuery && !isSearching && (!!results || !!error)
  }, /*#__PURE__*/React.createElement(StyledIconSearch, null, /*#__PURE__*/React.createElement(IconSearch2, null)), /*#__PURE__*/React.createElement("input", {
    name: "global-search",
    ref: innerRef,
    placeholder: placeholder,
    onChange: onChange,
    value: currentQuery,
    autoComplete: "off" // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: true,
    onKeyDown: onKeyDown // avoid type forward slice in the input when search is triggered
    ,
    onKeyPress: e => {
      if (!currentQuery && e.key === ACTIVE_GLOBAL_SEARCH_KEY) {
        e.preventDefault();
      }
    }
  }), currentQuery && isSearching && /*#__PURE__*/React.createElement(StyledCircleSpinner, null, /*#__PURE__*/React.createElement(CircleSpinnerInline, {
    size: 16
  })), currentQuery && /*#__PURE__*/React.createElement(StyledButtonIconReset, {
    onClick: handleOnReset
  }, /*#__PURE__*/React.createElement(IconClose, {
    color: colors.steel[400]
  })));
}
const StyledInputSearch = styled.div`
  --icon-size: 14px;
  --default-spacing: 12px;

  position: relative;
  z-index: 4;

  input {
    border-radius: 8px;
    ${_ref2 => {
  let {
    isResultActive
  } = _ref2;
  return isResultActive && css`
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      `;
}}
    border: none;

    box-sizing: border-box;
    display: block;
    font-family: ${fontFamilies.body};
    font-size: ${fontSizes.large.fontSize};
    height: 100%;
    min-height: 72px;
    padding: 1rem 2rem;
    padding-left: calc(1.5rem + var(--icon-size) + var(--default-spacing));
    text-decoration: none;
    text-overflow: ellipsis;
    width: 100%;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: rgba(84, 106, 131, 0.5);
    }
  }
`;
const StyledIconSearch = styled.div`
  left: 1.5rem;
  line-height: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: ${colors.steel[400]};
`;
const StyledButtonIconReset = styled.div`
  cursor: pointer;
  line-height: 0;
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
`;
const StyledCircleSpinner = styled.div`
  line-height: 0;
  position: absolute;
  right: calc(25px + var(--icon-size) + var(--default-spacing));
  top: 50%;
  transform: translateY(-50%);
`;

const BUGS_MESSAGE = 'Please contact #ask-bugs or bugs@newfront.com to solve this issue.';
function bugsMessage(baseMessage) {
  if (!baseMessage) {
    return BUGS_MESSAGE;
  }

  return `${baseMessage} ${BUGS_MESSAGE}`;
}

const ITEM_RESULT_TYPE = {
  account: 'ACCOUNT',
  document: 'DOCUMENT',
  policy: 'POLICY'
};
const HOVER_INTENT_INTERVAL_MS = 200;
function Result(_ref) {
  let {
    onClick,
    result,
    renderPreview,
    isActiveResult = false,
    onHover
  } = _ref;
  const [isHovering, ref] = useHoverIntent({
    interval: HOVER_INTENT_INTERVAL_MS,
    timeout: 100
  });
  const {
    description,
    hasViewAccess,
    label,
    routing,
    type
  } = result;
  const {
    isPopoverOpen,
    targetRef,
    openPopover,
    closePopover
  } = usePopover({
    excludeTarget: true
  });
  const anchorRef = targetRef;
  const wrapRef = ref;
  useEffect(() => {
    if (isHovering && isActiveResult) {
      openPopover();
    } else {
      closePopover();
    }
  }, [closePopover, isHovering, openPopover, isActiveResult]);
  useEffect(() => {
    if (isActiveResult) {
      var _anchorRef$current;

      (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 ? void 0 : _anchorRef$current.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [anchorRef, isActiveResult]);
  useEffect(() => {
    if (isHovering) {
      onHover === null || onHover === void 0 ? void 0 : onHover();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isHovering]);
  return /*#__PURE__*/React.createElement(StyledResultItem, {
    ref: wrapRef,
    role: "option",
    "aria-selected": isActiveResult
  }, /*#__PURE__*/React.createElement(StyledLink$1, {
    href: routing.absolute,
    onClick: e => {
      if (e.ctrlKey || e.metaKey) {
        return;
      }

      e.preventDefault();
      onClick();
    },
    ref: anchorRef
  }, !hasViewAccess && /*#__PURE__*/React.createElement(IconLock, null), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StyledTitle, null, ITEM_RESULT_TYPE[type]), /*#__PURE__*/React.createElement(Text, {
    weight: 600,
    color: colors.steel[500]
  }, label), description && /*#__PURE__*/React.createElement(Text, {
    weight: 400,
    color: colors.steel[500]
  }, description))), renderPreview && /*#__PURE__*/React.createElement(Tether, {
    targetRef: targetRef,
    targetAnchor: "left",
    anchor: "right",
    xOffset: -7
  }, /*#__PURE__*/React.createElement(PopoverAnimation, {
    isOpen: isPopoverOpen,
    direction: "right"
  }, renderPreview(result))));
}
const StyledLink$1 = styled.a`
  border: 0;
  border-left: solid 4px transparent;
  cursor: pointer;
  display: block;
  font-family: ${fontFamilies.body};
  padding: 11px 24px;
  position: relative;
  transition: all ease-in 0.2s;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 12px;
`;
const StyledResultItem = styled.li`
  list-style: none;

  &:hover,
  &:focus,
  &[aria-selected='true'] {
    ${StyledLink$1} {
      border-left-color: ${colors.brand[300]};
      background-color: ${colors.brand[100]};
    }
  }
`;
const StyledTitle = styled.h5`
  margin: 0;
  margin-bottom: 2px;
  font-size: 11px;
  line-height: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  color: ${colors.fire[400]};
`;

function Suggestion(_ref) {
  let {
    currentQuery,
    suggestion,
    onClick
  } = _ref;
  const [highlighted, rest] = useMemo(() => {
    let boundary = 0;

    for (let i = 0; i < currentQuery.length; i += 1) {
      if (i >= suggestion.length || currentQuery.charAt(i) !== suggestion.charAt(i)) break;
      boundary += 1;
    }

    return [suggestion.slice(0, boundary), suggestion.slice(boundary)];
  }, [currentQuery, suggestion]);
  return /*#__PURE__*/React.createElement(StyledSuggestionItem, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(IconSearch2, null), /*#__PURE__*/React.createElement(Box, {
    style: {
      marginLeft: 12
    }
  }, /*#__PURE__*/React.createElement(Text, {
    display: "inline",
    weight: 700
  }, highlighted), /*#__PURE__*/React.createElement(Text, {
    display: "inline"
  }, rest)));
}
const StyledSuggestionItem = styled.div`
  cursor: pointer;
  display: block;
  margin: 0;
  margin-bottom: 15px;
  font-style: italic;
  display: flex;
  align-items: center;

  svg {
    color: ${colors.steel[300]};
  }
`;

function Popout(_ref) {
  let {
    onRecentlySearchedClick,
    onRenderPreview,
    onSearchResultClick,
    onSearchSuggestionClick
  } = _ref;
  const {
    activeResultIndex,
    currentQuery,
    error,
    recentlySearched,
    recentlyVisited,
    results,
    setActiveResultIndex,
    suggestions
  } = useContext(SearchContext);
  const dvRef = useRef(null); // back to the initial position of the scroll

  useEffect(() => {
    if (activeResultIndex === 0) {
      var _dvRef$current;

      (_dvRef$current = dvRef.current) === null || _dvRef$current === void 0 ? void 0 : _dvRef$current.scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [activeResultIndex]);

  if (error) {
    var _error$data, _error$data2, _error$data2$errors;

    const customMessage = `${error.statusText}: ${((_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.errorMessage) || ((_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : (_error$data2$errors = _error$data2.errors) === null || _error$data2$errors === void 0 ? void 0 : _error$data2$errors[0]) || ''}`;
    return /*#__PURE__*/React.createElement(StyledContainer$1, null, /*#__PURE__*/React.createElement(Padding, {
      x: 24,
      y: 12
    }, /*#__PURE__*/React.createElement(Alert, null, /*#__PURE__*/React.createElement(Text, null, bugsMessage(`${error.data ? customMessage : 'There was a problem getting the search results.'}`)))));
  }

  const hasRecentlySearched = recentlySearched.length > 0;
  const hasRecentlyVisited = recentlyVisited.length > 0;
  const hasResults = results && results.length > 0;
  const hasSuggestions = suggestions && suggestions.length > 0;

  if ((hasRecentlySearched || hasRecentlyVisited) && !currentQuery) {
    return /*#__PURE__*/React.createElement(StyledContainer$1, null, hasRecentlySearched && /*#__PURE__*/React.createElement(Padding, {
      left: 24,
      bottom: hasRecentlyVisited ? 24 : 12
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      textAlign: "left",
      weight: 300,
      color: colors.steel[400]
    }, "Recently searched"), recentlySearched.map(item => /*#__PURE__*/React.createElement(Box, {
      key: item,
      onClick: () => onRecentlySearchedClick(item)
    }, /*#__PURE__*/React.createElement(Text, {
      marginTop: 12,
      marginBottom: 4,
      weight: 400
    }, item))))), hasRecentlyVisited && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Padding, {
      left: 24,
      x: 12
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      textAlign: "left",
      weight: 300,
      color: colors.steel[400]
    }, "Recently visited")), recentlyVisited.map(result => /*#__PURE__*/React.createElement(Result, {
      key: result.id,
      result: result,
      onClick: () => onSearchResultClick(result),
      renderPreview: onRenderPreview
    }))));
  }

  if (!results || !currentQuery) {
    return null;
  }

  return /*#__PURE__*/React.createElement(StyledContainer$1, {
    style: {
      minHeight: hasResults ? '460px' : 'auto'
    },
    ref: dvRef
  }, hasSuggestions && /*#__PURE__*/React.createElement(Padding, {
    top: hasSuggestions ? 8 : 0,
    x: 24
  }, suggestions === null || suggestions === void 0 ? void 0 : suggestions.filter(suggestion => suggestion !== currentQuery).map(suggestion => {
    return /*#__PURE__*/React.createElement(Suggestion, {
      key: suggestion,
      currentQuery: currentQuery,
      suggestion: suggestion,
      onClick: () => onSearchSuggestionClick(suggestion)
    });
  })), hasResults ? /*#__PURE__*/React.createElement("ul", {
    role: "listbox",
    "aria-labelledby": "global-search-label",
    style: {
      padding: 0
    }
  }, results.map((result, i) => /*#__PURE__*/React.createElement(Result, {
    isActiveResult: activeResultIndex === i,
    key: result.id,
    result: result,
    onClick: () => onSearchResultClick(result),
    onHover: () => setActiveResultIndex(i),
    renderPreview: onRenderPreview
  }))) : /*#__PURE__*/React.createElement(Padding, {
    size: 24
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    weight: 400,
    textAlign: "center",
    color: "secondary"
  }, "Sorry we couldn\u2019t find any matches"), /*#__PURE__*/React.createElement(Text, {
    weight: 400,
    textAlign: "center",
    color: "light"
  }, "Try other search terms"))));
}
const StyledContainer$1 = styled.div`
  background: #fff;
  border-top: 1px solid rgba(190, 199, 208, 0.5);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  box-sizing: border-box;
  left: 0;
  max-height: calc(100vh - 260px);
  overflow-y: overlay;
  overflow-x: hidden;
  padding: 12px 0;
  position: relative;
  width: 100%;
  z-index: 3;

  &::-webkit-scrollbar-track {
    background-color: #fff;
    position: absolute;
    border-bottom-right-radius: 4px;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: ${colors.steel[200]};
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 10px;
    background: ${colors.steel[200]};
    border: 2px solid #fff;
  }
`;

const DEFAULT_DEBOUNCE_MS = 300;
const SearchContainer = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    debounce = DEFAULT_DEBOUNCE_MS,
    error,
    initialValue,
    isSearching = false,
    maxWidth = '500px',
    onChange,
    onClickResultItem,
    onRenderPreview,
    onReset,
    onSelectSuggestion,
    onSetIsSearchActive,
    placeholder = 'Search...',
    // TODO(ACC-639): Implement recentlySearched & recentlyVisited
    recentlySearched = [],
    recentlyVisited = [],
    results,
    suggestions
  } = props;
  const [currentQuery, setCurrentQuery] = useState(initialValue || '');
  const [activeResultIndex, setActiveResultIndex] = useState(0);
  const inputRef = useRef();
  const debouncedOnChange = useDebouncedCallback(onChange, debounce);
  useEffect(() => {
    // reset results state if currentQuery is empty
    if (!currentQuery) {
      handleOnReset();
    }

    if (currentQuery && debouncedOnChange) {
      debouncedOnChange(currentQuery);
      setActiveResultIndex(0);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [currentQuery]);

  const handleOnReset = () => {
    setCurrentQuery('');
    setActiveResultIndex(0);
    onReset();
  };

  const handleSelectSuggestion = async suggestion => {
    var _inputRef$current;

    setCurrentQuery(suggestion);
    inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    await onSelectSuggestion(suggestion);
  };

  const handleKeyDown = useCallback(e => {
    const resultItems = results && results.length > 0 ? results : [];

    switch (e.key) {
      case 'ArrowDown':
        {
          e.preventDefault();
          setActiveResultIndex(activeResult => (activeResult + 1) % resultItems.length);
          break;
        }

      case 'ArrowUp':
        {
          e.preventDefault();
          setActiveResultIndex(activeResult => (activeResult + resultItems.length - 1) % resultItems.length);
          break;
        }

      case 'Enter':
        {
          onClickResultItem(resultItems[activeResultIndex]);
          break;
        }
    }
  }, [activeResultIndex, onClickResultItem, results]);
  const isKeyDownEnabled = !!(results && results.length > 0);
  return /*#__PURE__*/React.createElement(SearchContext.Provider, {
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    value: {
      currentQuery,
      isSearching,
      recentlySearched,
      recentlyVisited,
      results,
      activeResultIndex,
      setActiveResultIndex,
      setIsSearchActive: onSetIsSearchActive,
      suggestions,
      error
    }
  }, /*#__PURE__*/React.createElement(StyledSearch, {
    ref: ref,
    maxWidth: maxWidth
  }, /*#__PURE__*/React.createElement(InputSearch, {
    innerRef: inputRef,
    onChange: _ref => {
      let {
        target
      } = _ref;
      return setCurrentQuery(target.value);
    },
    onReset: handleOnReset,
    onKeyDown: isKeyDownEnabled ? handleKeyDown : undefined,
    placeholder: placeholder
  }), /*#__PURE__*/React.createElement(Popout, {
    onRenderPreview: onRenderPreview,
    onSearchResultClick: onClickResultItem,
    onSearchSuggestionClick: handleSelectSuggestion,
    onRecentlySearchedClick: value => setCurrentQuery(value)
  })));
});
SearchContainer.displayName = 'SearchContainer';
const StyledSearch = styled.div`
  position: relative;
  width: ${_ref2 => {
  let {
    maxWidth
  } = _ref2;
  return maxWidth;
}};
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-left: auto;
`;

function useAccountByUuid(params, config) {
  const {
    apiBasePath: basePath
  } = useProvider(LayoutConfigProvider);
  return useNextApiSubscription(routes.getAccountByUuid.getUrl({
    params,
    basePath
  }), config);
}

function useAccountManagers(config) {
  const {
    apiBasePath: basePath
  } = useProvider(LayoutConfigProvider);
  return useNextApiSubscription(routes.getAccountManagers.getUrl({
    basePath
  }), config);
}

function useOperationsEmployees(config) {
  const {
    apiBasePath: basePath
  } = useProvider(LayoutConfigProvider);
  return useNextApiSubscription(routes.getOperationsEmployees.getUrl({
    basePath
  }), config);
}

function useProducers(config) {
  const {
    apiBasePath: basePath
  } = useProvider(LayoutConfigProvider);
  return useNextApiSubscription(routes.getProducers.getUrl({
    basePath
  }), config);
}

const ACCOUNT_MANAGERS_KEY = 'accountManagers';
const PRODUCERS_KEY = 'producers';
const OPERATIONS_EMPLOYEES_KEY = 'operationsEmployees';

function toCachedEmployeesMap(employees, localStorageKey) {
  const mapEmployees = employeeList => {
    return toMap(employeeList, employee => employee.userUuid);
  };

  if (employees && employees.length > 0) {
    return mapEmployees(employees);
  } // this fallback is just a temporary optimization while the datasources for AMs and producers are so slow


  const localData = localStorage.getItem(localStorageKey);

  if (!localData) {
    return new Map();
  }

  try {
    const parsedData = JSON.parse(localData);

    if (!Array.isArray(parsedData)) {
      return new Map();
    }

    return mapEmployees(parsedData);
  } catch (error) {
    return new Map();
  }
}

function useEmployees() {
  const {
    data: accountManagers
  } = useAccountManagers();
  const {
    data: producers
  } = useProducers();
  const {
    data: operationsEmployees
  } = useOperationsEmployees();
  useEffect(() => {
    if (accountManagers) {
      localStorage.setItem(ACCOUNT_MANAGERS_KEY, JSON.stringify(accountManagers));
    }
  }, [accountManagers]);
  useEffect(() => {
    if (producers) {
      localStorage.setItem(PRODUCERS_KEY, JSON.stringify(producers));
    }
  }, [producers]);
  useEffect(() => {
    if (operationsEmployees) {
      localStorage.setItem(OPERATIONS_EMPLOYEES_KEY, JSON.stringify(operationsEmployees));
    }
  }, [operationsEmployees]);
  return {
    accountManagers: accountManagers || [],
    producers: producers || [],
    operationsEmployees: operationsEmployees || []
  };
}
function useEmployeesByUserUuid() {
  const {
    accountManagers,
    producers,
    operationsEmployees
  } = useEmployees();
  const accountManagersMap = useMemo(() => toCachedEmployeesMap(accountManagers, 'accountManagers'), [accountManagers]);
  const producersMap = useMemo(() => toCachedEmployeesMap(producers, 'producers'), [producers]);
  const operationsEmployeesMap = useMemo(() => toCachedEmployeesMap(operationsEmployees, 'operationsEmployees'), [operationsEmployees]);
  return {
    accountManagersMap,
    producersMap,
    operationsEmployeesMap
  };
}

function useServicingTeamForAccount() {
  const {
    accountManagersMap,
    producersMap,
    operationsEmployeesMap
  } = useEmployeesByUserUuid();
  const getServicingTeamForAccount = useCallback(withEmployeeRoleMappings => {
    const {
      employeeRoleMappings
    } = withEmployeeRoleMappings;
    const accountManagers = [...(employeeRoleMappings.PRIMARY_ACCOUNT_MANAGER || []), ...(employeeRoleMappings.SECONDARY_ACCOUNT_MANAGER || [])].map(roleMapping => accountManagersMap.get(roleMapping.userUuid));
    const producers = [...(employeeRoleMappings.PRIMARY_PRODUCER || []), ...(employeeRoleMappings.SECONDARY_PRODUCER || [])].map(roleMapping => producersMap.get(roleMapping.userUuid));
    const clientServiceAssociates = [...(employeeRoleMappings.CSA || [])].map(roleMapping => operationsEmployeesMap.get(roleMapping.userUuid));
    return [...accountManagers, ...producers, ...clientServiceAssociates].filter(isNotNil);
  }, [accountManagersMap, producersMap, operationsEmployeesMap]);
  return {
    getServicingTeamForAccount
  };
}

function useItemResultRouting() {
  const {
    router
  } = useRouter();

  const goToItemResultPage = async routing => {
    if (!router.basePath && routing.relative) {
      await router.push(routing.relative);
    } else if (window !== undefined) {
      window.location.href = routing.absolute;
    }
  };

  return {
    goToItemResultPage
  };
}

const LoadingWrapper = styled.div`
  align-items: center;
  background-color: ${colors.brand[100]};
  box-shadow: 2px -2px 8px 1px ${colors.brand[100]};
  display: flex;
  height: 52px;
  left: 53px;
  padding: 2px;
  position: relative;
`;

function ServicingTeam(_ref) {
  let {
    servicingTeam
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacing, {
    height: 24
  }), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, "Servicing team"), /*#__PURE__*/React.createElement(Spacing, {
    height: 8
  }), /*#__PURE__*/React.createElement(EmployeesRow, {
    employees: servicingTeam
  }));
}

function AccountCardPreview(_ref) {
  let {
    accountUuid,
    hasViewAccess,
    routing
  } = _ref;
  const {
    data: account,
    error
  } = useAccountByUuid({
    accountUuid,
    isPublic: !hasViewAccess
  });
  const {
    getServicingTeamForAccount
  } = useServicingTeamForAccount();
  const {
    goToItemResultPage
  } = useItemResultRouting();
  const {
    setIsSearchActive
  } = useContext(SearchContext);

  if (error) {
    return /*#__PURE__*/React.createElement(Box, {
      width: 512
    }, /*#__PURE__*/React.createElement(Alert, null, bugsMessage('Something went wrong trying to loading the account')));
  }

  if (!account) {
    return /*#__PURE__*/React.createElement(LoadingWrapper, null, /*#__PURE__*/React.createElement(CircleSpinnerInline, null));
  }

  const servicingTeam = getServicingTeamForAccount(account);
  const isArchived = account.status.status === AccountStatus.ARCHIVED;
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "#fff",
    borderRadius: 6,
    width: 512
  }, /*#__PURE__*/React.createElement(FeaturedCard, {
    eyebrow: "Account",
    title: account.name,
    href: routing.absolute,
    onClick: async e => {
      e.preventDefault();
      setIsSearchActive(false);
      await goToItemResultPage(routing);
    },
    subtitle: 'details' in account ? account.details.dba : account.dba,
    badge: isArchived ? /*#__PURE__*/React.createElement(Badge, null, "Archived") : null,
    content: /*#__PURE__*/React.createElement(React.Fragment, null, account.definitionListItems.length > 0 && /*#__PURE__*/React.createElement(DefinitionList, {
      items: account.definitionListItems
    }), servicingTeam.length > 0 && /*#__PURE__*/React.createElement(ServicingTeam, {
      servicingTeam: servicingTeam
    }))
  }));
}

function stringifyLinesOfCoverage(linesOfCoverage) {
  return linesOfCoverage.map(loc => {
    var _loc$definition;

    return `${(_loc$definition = loc.definition) === null || _loc$definition === void 0 ? void 0 : _loc$definition.readableName}${loc.displayName ? ` - ${loc.displayName}` : ''}`;
  }).join(', ') || '-';
}
function renderPolicyName(policyType, displayName) {
  if (displayName) {
    return `${displayName} - ${policyType}`;
  }

  return policyType;
}

function PolicyDefinitionList(props) {
  const {
    policy,
    onAccountClick
  } = props;
  return /*#__PURE__*/React.createElement(DefinitionList, {
    items: createPolicyDefinitionList({
      policy,
      onAccountClick
    }),
    labelWidth: "150px"
  });
}
function createPolicyDefinitionList(props) {
  const {
    policy,
    onAccountClick
  } = props;
  const {
    account,
    expirationDate,
    linesOfCoverage,
    effectiveDate,
    policyNumber,
    carrier
  } = policy;
  let items = [];

  if (account) {
    items.push({
      type: 'name',
      title: 'Client',
      value: (account === null || account === void 0 ? void 0 : account.name) || '-',
      href: `/accounts/${policy.accountUuid}`,
      onClick: onAccountClick
    });
  }

  items = [...items, {
    type: 'document',
    title: 'Line of coverage',
    value: stringifyLinesOfCoverage(linesOfCoverage)
  }, {
    type: 'dateRange',
    title: 'Effective dates',
    value: `${effectiveDate.format({
      style: DateFormatStyle.STANDARD
    })} - ${expirationDate.format({
      style: DateFormatStyle.STANDARD
    })}`
  }, {
    type: 'business',
    title: 'Carrier',
    value: (carrier === null || carrier === void 0 ? void 0 : carrier.name) || '-'
  }];

  if (policyNumber) {
    items.push({
      type: 'number',
      title: 'Policy number',
      value: policyNumber,
      target: '_blank'
    });
  }

  return items;
}

function PolicyCardPreview(_ref) {
  let {
    policyUuid,
    routing
  } = _ref;
  const {
    data: policy,
    error
  } = usePolicy({
    policyUuid
  });
  const {
    goToItemResultPage
  } = useItemResultRouting();
  const {
    setIsSearchActive
  } = useContext(SearchContext);

  if (error) {
    return /*#__PURE__*/React.createElement(Box, {
      width: 512
    }, /*#__PURE__*/React.createElement(Alert, null, bugsMessage('Something went wrong trying to load the policy')));
  }

  if (!policy) {
    return /*#__PURE__*/React.createElement(LoadingWrapper, null, /*#__PURE__*/React.createElement(CircleSpinnerInline, null));
  }

  const {
    accountUuid,
    details,
    definition,
    type,
    status,
    accountManagers,
    producers
  } = policy;
  const accountRouting = {
    absolute: `/accounts/${accountUuid}`,
    relative: {
      pathname: `/accounts/[accountUuid]`,
      query: {
        accountUuid
      }
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "#fff",
    borderRadius: 6,
    width: 512
  }, /*#__PURE__*/React.createElement(FeaturedCard, {
    eyebrow: "Policy",
    title: renderPolicyName((definition === null || definition === void 0 ? void 0 : definition.readableName) ?? type, details.displayName),
    href: routing.absolute,
    onClick: async e => {
      e.preventDefault();
      setIsSearchActive(false);
      await goToItemResultPage(routing);
    },
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PolicyDefinitionList, {
      policy: policy,
      onAccountClick: async e => {
        e.preventDefault();
        await goToItemResultPage(accountRouting);
      }
    }), (accountManagers.length > 0 || producers.length > 0) && /*#__PURE__*/React.createElement(ServicingTeam, {
      servicingTeam: [...accountManagers.map(am => ({ ...am,
        name: am.fullName,
        legacyId: am.deprecatedId,
        uuid: am.deprecatedUuid,
        type: EmployeeAvatarType.AccountManager
      })), ...producers.map(pd => ({ ...pd,
        name: pd.fullName,
        legacyId: pd.deprecatedId,
        uuid: pd.deprecatedUuid,
        type: EmployeeAvatarType.Producer
      }))]
    })),
    badge: status === PolicyStatus.ACTIVE ? /*#__PURE__*/React.createElement(Badge, {
      type: "success"
    }, "Active") : null
  }));
}

/**
 * Helper to build the card preview in base of the result type: account or policy...
 * @param result
 * @returns JSX.Element
 */

function RenderCardPreview(result) {
  return /*#__PURE__*/React.createElement(Card, {
    result: result
  });
}

function Card(_ref) {
  let {
    result
  } = _ref;
  const {
    type,
    id,
    hasViewAccess,
    routing
  } = result;

  switch (type) {
    case 'account':
      {
        return /*#__PURE__*/React.createElement(AccountCardPreview, {
          accountUuid: id,
          hasViewAccess: !!hasViewAccess,
          routing: routing
        });
      }

    case 'policy':
      {
        return /*#__PURE__*/React.createElement(PolicyCardPreview, {
          policyUuid: id,
          routing: routing
        });
      }

    default:
      return null;
  }
}

function useSearchEngineApi() {
  const fetch = useNextApiFetch();
  const {
    apiBasePath
  } = useProvider(LayoutConfigProvider);
  return {
    getSearchResults(body) {
      return fetch({
        method: 'POST',
        url: urlcat(apiBasePath, routes.searchEngine.getUrl({})),
        body
      });
    }

  };
}

function useSearchEngine() {
  const searchEngineApi = useSearchEngineApi();

  const getSearchResults = async body => {
    return searchEngineApi.getSearchResults(body);
  };

  return {
    getSearchResults
  };
}

function useGlobalSearch() {
  const getToken = useGoogleToken();
  const {
    getSearchResults
  } = useSearchEngine();
  const [queryValue, setQueryValue] = useState(null);
  const [withSuggestions, setWithSuggestions] = useState(true);
  const token = getToken();
  const {
    data,
    isValidating,
    error
  } = useSWR(queryValue && token ? [queryValue, token] : null, async (value, authToken) => {
    const results = await getSearchResults({
      query: value,
      authToken
    });
    return results;
  });

  const handleSearch = async function (value) {
    let withSuggestionsOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!value) {
      return;
    }

    if (withSuggestions !== withSuggestionsOverride) {
      setWithSuggestions(withSuggestionsOverride);
    }

    setQueryValue(value);
  };

  const handleReset = () => {
    setQueryValue('');
  };

  const handleSelectSuggestion = async suggestion => {
    await handleSearch(suggestion, false);
  };

  return {
    handleSearch,
    handleReset,
    handleSelectSuggestion,
    isLoading: isValidating,
    results: queryValue ? data === null || data === void 0 ? void 0 : data.searchResults : undefined,
    suggestions: queryValue && withSuggestions ? data === null || data === void 0 ? void 0 : data.searchSuggestions : undefined,
    error
  };
}

function GlobalSearch(_ref) {
  let {
    setIsSearchActive
  } = _ref;
  const {
    handleSearch,
    isLoading,
    results,
    suggestions,
    handleReset,
    handleSelectSuggestion,
    error
  } = useGlobalSearch();
  const innerRef = /*#__PURE__*/React.createRef();
  useOnClickOutside(innerRef, () => {
    setIsSearchActive(false);
  });
  useKeyEvent('Escape', () => setIsSearchActive(false), []);
  const {
    goToItemResultPage
  } = useItemResultRouting();
  return /*#__PURE__*/React.createElement(StyledOverlay, null, /*#__PURE__*/React.createElement(SearchContainer, {
    ref: innerRef,
    isSearching: isLoading,
    maxWidth: "700px",
    onChange: handleSearch,
    onClickResultItem: async data => {
      setIsSearchActive(false);
      await goToItemResultPage(data.routing);
    },
    onSetIsSearchActive: setIsSearchActive,
    onSelectSuggestion: handleSelectSuggestion,
    onReset: handleReset,
    onRenderPreview: RenderCardPreview,
    placeholder: "Search...",
    results: results,
    suggestions: suggestions,
    error: error
  }));
}
const StyledOverlay = styled.div`
  background: rgb(0, 0, 0, 0.3);
  transition: background ease-in-out 0.4ms;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zIndices.overlay};
  padding: 7px;
`;

function SearchButton() {
  const [isSearchActive, setIsSearchActive] = useState(false);
  useKeyEvent(ACTIVE_GLOBAL_SEARCH_KEY, () => {
    const {
      activeElement
    } = document;

    if ((activeElement === null || activeElement === void 0 ? void 0 : activeElement.tagName) !== 'BODY') {
      return;
    }

    setIsSearchActive(true);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    message: "Search",
    command: "/",
    positionTip: "bottom",
    offset: "5px"
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    tabIndex: 0,
    title: "Search",
    "data-active": isSearchActive,
    onClick: async e => {
      e.preventDefault();
      setIsSearchActive(isActive => !isActive);
    }
  }, /*#__PURE__*/React.createElement(IconSearch2, null))), isSearchActive && /*#__PURE__*/React.createElement(Portal, {
    name: "global-search"
  }, /*#__PURE__*/React.createElement(GlobalSearch, {
    setIsSearchActive: setIsSearchActive
  })));
}

function AppHeader(_ref) {
  let {
    homeRoute,
    leftToolbar,
    rightToolbar
  } = _ref;
  const {
    createLink
  } = useRouter();
  const {
    currentApp
  } = useProvider(LayoutConfigProvider);
  const homeLink = createLink(homeRoute ?? {
    pathname: '/'
  });
  return /*#__PURE__*/React.createElement(StyledNavigation, null, /*#__PURE__*/React.createElement(Flexbox, {
    alignItems: "center",
    gap: 16
  }, /*#__PURE__*/React.createElement(StyledAppLabelLink, {
    href: homeLink.href,
    onClick: homeLink.onClick,
    title: "Go back home"
  }, /*#__PURE__*/React.createElement(AppBadge, {
    type: currentApp,
    textSize: "large",
    iconSize: 40
  })), leftToolbar), /*#__PURE__*/React.createElement(Stack, {
    gap: 12,
    direction: "horizontal",
    alignItems: "center"
  }, rightToolbar, /*#__PURE__*/React.createElement(Stack, {
    gap: 2,
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(SearchButton, null), /*#__PURE__*/React.createElement(AppSwitcherButton, null)), /*#__PURE__*/React.createElement(AccountMenu, null)));
}
const StyledAppLabelLink = styled.a`
  display: block;
  text-decoration: none;
  border-radius: 4px;
  padding: 8px;
  margin: -8px;

  &:hover {
    background-color: ${colors.steel[100]};
  }
`;
const StyledNavigation = styled.div({
  alignItems: 'center',
  background: '#fff',
  borderBottom: '1px solid #BEC7D050',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  height: '72px',
  justifyContent: 'space-between',
  padding: '0 24px',
  position: 'relative',
  zIndex: 5
});

const StyledPre = styled.pre`
  white-space: pre-wrap;
  word-break: break-word;
  background: ${colors.steel[50]};
  padding: 12px;
`;
const StyledContainer = styled.div`
  max-width: 550px;
  margin: 0 auto;
  padding: 80px 20px;
`;
/**
 * This component can be used to render a full page error message. It will fill the content area
 * of the page and centre the error message.
 */

function ErrorMessage(_ref) {
  let {
    title,
    subtitle,
    icon,
    action,
    rawErrorMessage
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(Stack, {
    direction: "vertical",
    gap: 24,
    alignItems: "center",
    justifyItems: "center"
  }, icon, /*#__PURE__*/React.createElement(Stack, {
    direction: "vertical",
    gap: 4,
    alignItems: "center",
    justifyItems: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement("strong", null, title)), /*#__PURE__*/React.createElement(Text, {
    textAlign: "center"
  }, subtitle)), action, rawErrorMessage && /*#__PURE__*/React.createElement(StyledPre, null, rawErrorMessage)));
}

function ErrorBoundaryWithMessages(_ref) {
  let {
    children,
    onError,
    messages
  } = _ref;
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    onError: onError,
    fallbackRender: _ref2 => {
      let {
        error
      } = _ref2;
      const message = getPreferredErrorMessage(error); // If it's a TRPCClientError we want to use the cause of the error instead. Otherwise
      // the error message won't be useful.

      const errorCause = isTRPCClientError(error) && error.cause ? error.cause : error;

      if (isPermissionError(errorCause)) {
        return /*#__PURE__*/React.createElement(ErrorMessage, messages.permissionError(errorCause));
      }

      if (isTimeoutError(errorCause)) {
        return /*#__PURE__*/React.createElement(ErrorMessage, messages.timeoutError(errorCause));
      }

      if (isNetworkError(errorCause)) {
        return /*#__PURE__*/React.createElement(ErrorMessage, messages.networkError(errorCause));
      }

      if (isNotFoundError(errorCause)) {
        return /*#__PURE__*/React.createElement(ErrorMessage, messages.notFoundError(errorCause));
      }

      if (isNotLoggedInError(errorCause)) {
        return /*#__PURE__*/React.createElement(ErrorMessage, messages.notLoggedInError(errorCause));
      } // Capture any other HTTP error, like a 400 or 50x error. This will show the NestJS error message
      // or fetcher error. Any other type error will just show the error.message.


      return /*#__PURE__*/React.createElement(ErrorMessage, _extends({}, messages.genericError(errorCause), {
        rawErrorMessage: message
      }));
    }
  }, children);
}

/* eslint-disable react/function-component-definition */
const ASK_BUGS_HREF = 'https://app.slack.com/client/TVBSAQNLS/CPM6JUMCN';
const ASK_PRODUCT_HREF = 'https://app.slack.com/client/TVBSAQNLS/C02EE2ER953';

const AskProductButton = () => /*#__PURE__*/React.createElement(Button, {
  size: "secondary",
  href: ASK_PRODUCT_HREF,
  target: "_blank",
  style: {
    textAlign: 'center'
  }
}, "Ask in Slack...");

const AskBugsButton = () => /*#__PURE__*/React.createElement(Button, {
  size: "secondary",
  href: ASK_BUGS_HREF,
  target: "_blank",
  style: {
    textAlign: 'center'
  }
}, "Ask in Slack...");

const ReloadButton = () => /*#__PURE__*/React.createElement(Button, {
  size: "secondary",
  onClick: () => window.location.reload()
}, "Try again");

const employeeErrorMessages = {
  genericError: _error => {
    return {
      title: 'There was a problem loading this page',
      icon: /*#__PURE__*/React.createElement(IconBug, null),
      action: /*#__PURE__*/React.createElement(AskBugsButton, null),
      subtitle: 'Try reloading the page to fix the issue. If you’re still experiencing this issue you can ask in #ask-bugs.'
    };
  },
  notFoundError: _error => ({
    title: 'The page you’re looking for doesn’t exist',
    icon: /*#__PURE__*/React.createElement(IconNotFound, null),
    action: /*#__PURE__*/React.createElement(AskBugsButton, null),
    subtitle: 'Check the URL. If you think this is a mistake please contact #ask-bugs.'
  }),
  permissionError: _error => ({
    title: 'You don’t have access to this page',
    icon: /*#__PURE__*/React.createElement(IconNotAllowed, null),
    action: /*#__PURE__*/React.createElement(AskProductButton, null),
    subtitle: 'If you think this is a mistake you can ask the team in #ask-product.'
  }),
  networkError: _error => ({
    title: 'There was a network connection issue that prevented this page from loading',
    icon: /*#__PURE__*/React.createElement(IconNetworkLost, null),
    action: /*#__PURE__*/React.createElement(ReloadButton, null),
    subtitle: 'Please check your internet connection and try again.'
  }),
  timeoutError: _error => ({
    title: 'The page took too long to load',
    icon: /*#__PURE__*/React.createElement(IconNetworkLost, null),
    action: /*#__PURE__*/React.createElement(ReloadButton, null),
    subtitle: 'Please check your internet connection and try again. If the issue persists please contact #ask-bugs.'
  }),
  notLoggedInError: _error => ({
    title: 'You need to be logged in to view this page',
    icon: /*#__PURE__*/React.createElement(IconNotAllowed, null),
    subtitle: 'If you think this is a mistake you can ask the team in #ask-product.'
  })
};

/**
 * This error boundary should only be used in internal apps. It will define the copy for the
 * error messages and assume the user is an employee.
 */

function InternalAppErrorBoundary(_ref) {
  let {
    children
  } = _ref;
  const {
    onError
  } = useProvider(LayoutConfigProvider);
  return /*#__PURE__*/React.createElement(ErrorBoundaryWithMessages, {
    onError: onError,
    messages: employeeErrorMessages
  }, children);
}

function BackButton(props) {
  const {
    label,
    link
  } = props;
  return /*#__PURE__*/React.createElement(Tooltip, {
    message: label
  }, /*#__PURE__*/React.createElement(StyledBackButton, {
    href: link.href,
    onClick: link.onClick
  }, /*#__PURE__*/React.createElement(Arrow, null)));
}
const StyledBackButton = styled.a`
  cursor: pointer;
  position: relative;
  align-items: center;
  display: flex;
  width: fit-content;

  &:hover {
    background: ${colors.steel[100]};
    border-radius: 100px;
    box-shadow: 0 0 0 10px ${colors.steel[100]};
  }
`;

function Breadcrumbs(props) {
  const {
    crumbs
  } = props;
  return /*#__PURE__*/React.createElement(Stack, {
    direction: "horizontal",
    gap: 4
  }, crumbs.map((crumb, i) => {
    if (i === crumbs.length - 1) {
      return /*#__PURE__*/React.createElement(Text, {
        key: crumb.label,
        size: "small",
        color: colors.steel[400]
      }, crumb.label);
    }

    return /*#__PURE__*/React.createElement(Text, {
      key: crumb.label,
      size: "small",
      color: colors.steel[400]
    }, /*#__PURE__*/React.createElement(Stack, {
      direction: "horizontal",
      gap: 4,
      alignItems: "center"
    }, crumb.link ? /*#__PURE__*/React.createElement(TextLink, {
      underline: false,
      variant: "secondary",
      style: {
        font: 'inherit'
      },
      href: crumb.link.href,
      onClick: crumb.link.onClick
    }, crumb.label) : /*#__PURE__*/React.createElement(Text, {
      key: crumb.label,
      size: "small",
      color: colors.steel[400]
    }, crumb.label), /*#__PURE__*/React.createElement("svg", {
      height: "8",
      width: "8",
      viewBox: "0 0 12 12"
    }, /*#__PURE__*/React.createElement("g", {
      fill: colors.steel[400]
    }, /*#__PURE__*/React.createElement("path", {
      d: "M11.707,5.293,7,.586,5.586,2l3,3H0V7H8.586l-3,3L7,11.414l4.707-4.707A1,1,0,0,0,11.707,5.293Z",
      fill: colors.steel[400]
    })))));
  }));
}

function ActionButton(props) {
  const {
    disabled,
    isExternal,
    label,
    link,
    loading,
    variant = 'secondary'
  } = props;
  return /*#__PURE__*/React.createElement(Button, {
    style: {
      height: 32,
      lineHeight: '30px'
    },
    target: isExternal ? '_blank' : undefined,
    href: link.href,
    onClick: link.onClick,
    size: variant,
    loading: loading,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: 8,
    alignItems: "center"
  }, label, isExternal && /*#__PURE__*/React.createElement(IconExternal, null)));
}

function PageHeaderActions(props) {
  const {
    buttons
  } = props;

  if (buttons.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Stack, {
    gap: 4,
    justifyContent: "flex-end",
    alignItems: "center"
  }, buttons.map(button => /*#__PURE__*/React.createElement(ActionButton, _extends({
    key: button.label
  }, button))));
}

function PageHeader(props) {
  const {
    title,
    subtitle,
    actions = [],
    onBack,
    additionalActions,
    overflowActions,
    overflowActionsGroup,
    breadcrumbs
  } = props;
  return /*#__PURE__*/React.createElement(StyledHeader, null, onBack && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flexbox, {
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(BackButton, {
    label: onBack.label,
    link: onBack.link
  })), /*#__PURE__*/React.createElement(Spacing, {
    width: 24
  })), /*#__PURE__*/React.createElement(Flexbox, {
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: 0,
    direction: "vertical",
    alignItems: "center"
  }, typeof title === 'string' ? /*#__PURE__*/React.createElement(Text, {
    size: "large",
    color: colors.steel[500]
  }, title) : title, breadcrumbs && /*#__PURE__*/React.createElement(Breadcrumbs, {
    crumbs: breadcrumbs
  }), subtitle && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: colors.steel[400]
  }, subtitle)), /*#__PURE__*/React.createElement(Stack, {
    gap: 12,
    alignItems: "center"
  }, additionalActions && /*#__PURE__*/React.createElement(Flexbox, {
    alignContent: "center"
  }, additionalActions), /*#__PURE__*/React.createElement(PageHeaderActions, {
    buttons: actions
  }), (overflowActions || overflowActionsGroup) && /*#__PURE__*/React.createElement(Popper, {
    trigger: _ref => {
      let {
        toggle,
        triggerRef
      } = _ref;
      return /*#__PURE__*/React.createElement(IconButton, {
        type: "more",
        onClick: toggle,
        elementRef: triggerRef
      });
    }
  }, _ref2 => {
    let {
      toggle
    } = _ref2;
    return /*#__PURE__*/React.createElement(Menu2, {
      onItemClick: toggle,
      items: createMenuItems(overflowActions, overflowActionsGroup)
    });
  }))));
}

function createMenuItems(actions, actionsGroup) {
  const items = [];
  actions === null || actions === void 0 ? void 0 : actions.forEach(action => {
    items.push(createMenuLink(action));
  });
  actionsGroup === null || actionsGroup === void 0 ? void 0 : actionsGroup.forEach(actionGroup => {
    if (actionGroup.title) {
      items.push({
        type: MenuItemType.TITLE,
        title: actionGroup.title
      });
    }

    actionGroup.links.forEach(actionGroupItem => {
      items.push(createMenuLink(actionGroupItem));
    });
  });
  return items;
}

function createMenuLink(action) {
  const {
    target
  } = action;
  const {
    href,
    onClick
  } = action.link;
  return {
    type: MenuItemType.LINK,
    label: action.label,
    onClick,
    href,
    target
  };
}

const StyledHeader = styled.div`
  flex: none;
  padding: 0 24px;
  height: 80px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${colors.border.default};
  background: white;
`;

let LinkType;

(function (LinkType) {
  LinkType["ROUTE"] = "ROUTE";
  LinkType["EXTERNAL"] = "EXTERNAL";
  LinkType["ACTION"] = "ACTION";
})(LinkType || (LinkType = {}));

function isRouteLink(linkItem) {
  return linkItem.type === LinkType.ROUTE;
}
function isActionLink(linkItem) {
  return linkItem.type === LinkType.ACTION;
}

function BottomLinkComponent(props) {
  const {
    bottomLink
  } = props;
  const {
    linkItem
  } = bottomLink;

  if (isActionLink(linkItem)) {
    const {
      label,
      onClick,
      isActive = false,
      isDisabled = false,
      tooltipText
    } = linkItem;
    return /*#__PURE__*/React.createElement(Tooltip, {
      message: tooltipText
    }, /*#__PURE__*/React.createElement(TileLink, {
      label: label,
      onClick: onClick,
      "data-active": isActive,
      disabled: isDisabled
    }));
  }

  if (isRouteLink(linkItem)) {
    const {
      label,
      link,
      badgeCount,
      isDisabled = false,
      target,
      tooltipText
    } = linkItem;
    return /*#__PURE__*/React.createElement(Tooltip, {
      message: tooltipText
    }, /*#__PURE__*/React.createElement(TileLink, {
      label: label,
      "data-active": link.isActive,
      onClick: link.onClick,
      "data-count": badgeCount,
      disabled: isDisabled,
      target: target,
      href: link.href
    }));
  } // External link


  return /*#__PURE__*/React.createElement(Tooltip, {
    message: linkItem.tooltipText
  }, /*#__PURE__*/React.createElement(TileLink, {
    href: linkItem.href,
    disabled: linkItem.isDisabled,
    label: linkItem.label,
    target: linkItem.target
  }));
}

/* eslint-disable max-len */
function NavigationItem(props) {
  const {
    linkItem
  } = props;

  if (isActionLink(linkItem)) {
    const {
      label,
      onClick,
      isActive = false,
      isDisabled = false,
      showExternalIcon = false,
      tooltipText
    } = linkItem;
    return /*#__PURE__*/React.createElement(Tooltip, {
      message: tooltipText
    }, /*#__PURE__*/React.createElement(StyledLink, {
      onClick: onClick,
      "data-active": isActive,
      "data-disabled": isDisabled
    }, /*#__PURE__*/React.createElement(StyledLinkText, null, label), showExternalIcon && /*#__PURE__*/React.createElement(IconExternal2, null)));
  }

  if (isRouteLink(linkItem)) {
    const {
      label,
      link,
      badgeCount,
      isDisabled = false,
      target = '_self',
      tooltipText
    } = linkItem;
    return /*#__PURE__*/React.createElement(Tooltip, {
      message: tooltipText
    }, /*#__PURE__*/React.createElement(StyledLink, {
      "data-active": link.isActive,
      href: link.href,
      onClick: link.onClick,
      "data-count": badgeCount,
      "data-disabled": isDisabled,
      target: target
    }, /*#__PURE__*/React.createElement(StyledLinkText, null, label)));
  } // External link or Conditional link with activeType set to external


  return /*#__PURE__*/React.createElement(Tooltip, {
    message: linkItem.tooltipText
  }, /*#__PURE__*/React.createElement(StyledLink, {
    href: linkItem.href,
    "data-disabled": linkItem.isDisabled,
    target: linkItem.target
  }, /*#__PURE__*/React.createElement(StyledLinkText, null, linkItem.label), /*#__PURE__*/React.createElement(IconExternal2, null)));
}
const StyledLinkText = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
`;
const StyledLink = styled.a`
  color: ${colors.steel[500]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  border-radius: 4px;
  line-height: 32px;
  box-sizing: border-box;
  font-family: ${fontFamilies.body};
  font-size: ${fontSizes.regular.fontSize};
  padding: 0 8px 0;
  cursor: pointer;
  overflow: hidden;
  position: relative;

  &[data-active='true'] {
    color: ${colors.brand[100]};
    background: ${colors.brand[400]};
  }

  &:hover:not([data-active='true']) {
    color: ${colors.brand[300]};
    background: ${colors.steel[100]};
  }

  &[data-count]::after {
    content: attr(data-count);
    display: block;
    background: ${colors.brand[100]};
    color: ${colors.brand[400]};
    border-radius: 2px;
    line-height: 16px;
    padding: 2px 6px;
    margin-left: 4px;
    font-size: ${fontSizes.small.fontSize};
  }

  &[data-count][data-active='true']::after {
    background: ${colors.brand[300]};
    color: ${colors.brand[100]};
  }

  &[data-icon='external']::after {
    display: block;
  }

  &[data-disabled='true'] {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

function NavigationLinkGroup(props) {
  const {
    group
  } = props;
  return /*#__PURE__*/React.createElement(Stack, {
    direction: "vertical",
    gap: 8
  }, group.title ? /*#__PURE__*/React.createElement(StyledGroupNameWrapper, null, /*#__PURE__*/React.createElement(StyledLabel, null, group.title)) : null, /*#__PURE__*/React.createElement(Stack, {
    direction: "vertical",
    gap: 2
  }, group.links.map(linkItem => {
    return /*#__PURE__*/React.createElement(NavigationItem, {
      linkItem: linkItem,
      key: linkItem.label
    });
  })));
}
const StyledLabel = styled.div`
  color: ${colors.steel[300]};
  font-family: ${fontFamilies.body};
  font-weight: 600;
  font-size: ${fontSizes.small.fontSize};
  line-height: 20px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;
const StyledGroupNameWrapper = styled.div`
  padding-left: 8px;
`;

function createGroupKey(group) {
  return btoa(group.links.map(link => link.label).join('-'));
}

function PageSidebar(props) {
  const {
    linkGroups,
    children,
    bottomLink
  } = props;
  return /*#__PURE__*/React.createElement(Container, null, linkGroups && /*#__PURE__*/React.createElement(Sidebar, {
    style: {
      paddingBottom: bottomLink ? 0 : 24
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: 40,
    direction: "vertical"
  }, linkGroups.map(group => /*#__PURE__*/React.createElement(NavigationLinkGroup, {
    group: group,
    key: createGroupKey(group)
  }))), bottomLink && /*#__PURE__*/React.createElement(Padding, {
    top: 40,
    style: {
      position: 'sticky',
      bottom: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: '#fff',
      padding: '12px 0 24px 0'
    }
  }, /*#__PURE__*/React.createElement(BottomLinkComponent, {
    bottomLink: bottomLink
  })))), /*#__PURE__*/React.createElement(Content, null, children));
}
const Container = styled.div`
  display: flex;
  align-items: stretch;
  overflow-y: hidden;
  height: 100%;
`;
const Sidebar = styled.div`
  width: 280px;
  border-right: 1px solid ${colors.border.default};
  background: white;
  padding: 24px 16px;
  box-sizing: border-box;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
`;
const Content = styled.div`
  overflow-y: auto;
  width: 100%;
  position: relative;
`;

/* eslint-disable max-len */
function PlanIcon(_ref) {
  let {
    color = colors.steel[500]
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 1L14.9999 3.33333L7.53327 10.8L4.2666 11.7333L5.19993 8.46667L12.6666 1Z",
    stroke: color,
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 2.86664L13.1334 5.19997",
    stroke: color,
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1333 9.39997V14.0666C13.1333 14.5818 12.7152 15 12.2 15H1.93333C1.41813 15 1 14.5818 1 14.0666V3.79997C1 3.28477 1.41813 2.86664 1.93333 2.86664H6.6",
    stroke: color,
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function SubmitIcon(_ref2) {
  let {
    color = colors.steel[500]
  } = _ref2;
  return /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "14",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.28564 6.99988H13.8571",
    stroke: color,
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4285 3.57123L13.857 6.9998L10.4285 10.4284",
    stroke: color,
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85714 13H1.85714C1.384 13 1 12.616 1 12.1429V1.85714C1 1.384 1.384 1 1.85714 1H7.85714",
    stroke: color,
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function CompareIcon(_ref3) {
  let {
    color = colors.steel[500]
  } = _ref3;
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "9",
    viewBox: "0 0 20 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 4.59967H11.8",
    stroke: color,
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 1L11.8 4.6L15.4 8.2",
    stroke: color,
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 4.59967H8.2",
    stroke: color,
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6001 1L8.2001 4.6L4.6001 8.2",
    stroke: color,
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function PrepareIcon(_ref4) {
  let {
    color = colors.steel[500]
  } = _ref4;
  return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "16",
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2667 1.93311H12.2C12.4475 1.93311 12.6849 2.03144 12.86 2.20647C13.035 2.38151 13.1333 2.6189 13.1333 2.86644V14.0664C13.1333 14.314 13.035 14.5514 12.86 14.7264C12.6849 14.9014 12.4475 14.9998 12.2 14.9998H1.93333C1.6858 14.9998 1.4484 14.9014 1.27337 14.7264C1.09833 14.5514 1 14.314 1 14.0664V2.86644C1 2.6189 1.09833 2.38151 1.27337 2.20647C1.4484 2.03144 1.6858 1.93311 1.93333 1.93311H2.86667",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40006 1H4.7334V2.86667H9.40006V1Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 8.93356L6.13327 10.8002L9.8666 7.06689",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function FolderIcon(_ref5) {
  let {
    color = colors.steel[500]
  } = _ref5;
  return /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "14",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 3.4L5.8 1H1V11.8C1 12.1183 1.12643 12.4235 1.35147 12.6485C1.57652 12.8736 1.88174 13 2.2 13H13C13.3183 13 13.6235 12.8736 13.8485 12.6485C14.0736 12.4235 14.2 12.1183 14.2 11.8V3.4H7Z",
    stroke: color,
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function ProposeIcon(_ref7) {
  let {
    color = colors.steel[500]
  } = _ref7;
  return /*#__PURE__*/React.createElement("svg", {
    width: "13",
    height: "15",
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93333 14H1V1H12.2667V9.66667L7.93333 14Z",
    stroke: color,
    strokeWidth: "0.75",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93359 14V9.66663H12.2669",
    stroke: color,
    strokeWidth: "0.75",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60034 4.46667H9.66701",
    stroke: color,
    strokeWidth: "0.75",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60034 7.06665H9.66701",
    stroke: color,
    strokeWidth: "0.75",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60034 9.66663H5.33368",
    stroke: color,
    strokeWidth: "0.75",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function BindIcon(_ref8) {
  let {
    color = colors.steel[500]
  } = _ref8;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.82764 11.3447L5.9155 7.25684",
    stroke: color,
    strokeWidth: "0.75",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03453 1L3.48281 3.06897L1.82764 11.3448L10.1035 9.68966L12.1725 5.13793L8.03453 1Z",
    stroke: color,
    strokeWidth: "0.75",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67094 7.25717C8.15572 6.77239 8.15572 5.9864 7.67094 5.50162C7.18615 5.01683 6.40016 5.01683 5.91538 5.50162C5.43059 5.9864 5.43059 6.77239 5.91538 7.25717C6.40016 7.74196 7.18615 7.74196 7.67094 7.25717Z",
    stroke: color,
    strokeWidth: "0.75",
    strokeMiterlimit: "10",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13H13.4138",
    stroke: "#262D46",
    strokeWidth: "0.75",
    strokeMiterlimit: "10",
    strokeLinecap: "square"
  }));
}
function FilesIcon(_ref9) {
  let {
    color = colors.brand[400]
  } = _ref9;
  return /*#__PURE__*/React.createElement("svg", {
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 5.00001V3.00001H6.00001L5.00001 1H1V12",
    stroke: color,
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 15L5.00001 7H16L13 15H2Z",
    stroke: color,
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

let TabIcon$1;

(function (TabIcon) {
  TabIcon["FILES"] = "FILES";
  TabIcon["BIND"] = "BIND";
  TabIcon["COMPARE"] = "COMPARE";
  TabIcon["FOLDER"] = "FOLDER";
  TabIcon["PLAN"] = "PLAN";
  TabIcon["PREPARE"] = "PREPARE";
  TabIcon["PROPOSE"] = "PROPOSE";
  TabIcon["SUBMIT"] = "SUBMIT";
})(TabIcon$1 || (TabIcon$1 = {}));

const ICON_MAP = {
  [TabIcon$1.FILES]: FilesIcon,
  [TabIcon$1.BIND]: BindIcon,
  [TabIcon$1.COMPARE]: CompareIcon,
  [TabIcon$1.FOLDER]: FolderIcon,
  [TabIcon$1.PLAN]: PlanIcon,
  [TabIcon$1.PREPARE]: PrepareIcon,
  [TabIcon$1.PROPOSE]: ProposeIcon,
  [TabIcon$1.SUBMIT]: SubmitIcon
};
function PageTabs(props) {
  const {
    tabs
  } = props;
  return /*#__PURE__*/React.createElement(StyledTabWrapper, null, /*#__PURE__*/React.createElement(StyledTabs, null, /*#__PURE__*/React.createElement(Stack, {
    gap: 32,
    direction: "horizontal"
  }, tabs.map(tab => /*#__PURE__*/React.createElement(StyledTab, {
    key: tab.label,
    role: "tab",
    isActive: tab.link.isActive ?? false,
    onClick: tab.link.onClick,
    href: tab.link.href
  }, /*#__PURE__*/React.createElement(Flexbox, {
    alignItems: "center",
    height: "48px"
  }, ICON_MAP[tab.icon]({}), /*#__PURE__*/React.createElement(Spacing, {
    width: 8
  }), /*#__PURE__*/React.createElement(Text, null, tab.label)))))));
}
const StyledTabWrapper = styled.nav`
  padding: 0 24px;
  background: white;
  border-bottom: 1px solid ${colors.border.default};
  position: sticky;
  top: 0;
`;
const StyledTabs = styled.nav`
  position: relative;
  display: flex;
  justify-content: flex-start;
  height: 48px;
`;
const StyledTab = styled.a`
  cursor: pointer;
  text-decoration: none;

  box-shadow: ${_ref => {
  let {
    isActive
  } = _ref;
  return isActive ? `inset 0 -4px 0 ${colors.brand[400]}` : 'none';
}};

  &:hover {
    box-shadow: ${_ref2 => {
  let {
    isActive
  } = _ref2;
  return isActive ? `inset 0 -4px 0 ${colors.brand[400]}` : `inset 0 -4px 0 ${colors.steel[200]}`;
}};
  }
`;

const pageBackgroundColor = {
  gray: colors.steel[100],
  white: '#fff'
};
function PageLayout(props) {
  const {
    pageTitle,
    pageTabs,
    pageSubtitle,
    onBack,
    breadcrumbs,
    bottomLink,
    pagePrimaryActions,
    pageOverflowActions,
    pageOverflowGroupActions,
    pageAdditionalHeaderContent,
    pageLinks,
    children,
    background = 'white'
  } = props;
  return /*#__PURE__*/React.createElement(Flexbox, {
    flex: "1",
    flexDirection: "column",
    style: {
      overflow: 'hidden'
    }
  }, pageTitle && /*#__PURE__*/React.createElement(PageHeader, {
    title: pageTitle,
    subtitle: pageSubtitle,
    onBack: onBack,
    breadcrumbs: breadcrumbs,
    actions: pagePrimaryActions,
    overflowActions: pageOverflowActions,
    overflowActionsGroup: pageOverflowGroupActions,
    additionalActions: pageAdditionalHeaderContent
  }), pageTabs && /*#__PURE__*/React.createElement(PageTabs, {
    tabs: pageTabs
  }), /*#__PURE__*/React.createElement(StyledPageContent, {
    background: background
  }, /*#__PURE__*/React.createElement(PageSidebar, {
    linkGroups: pageLinks,
    bottomLink: bottomLink
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(CircleSpinner, null)
  }, /*#__PURE__*/React.createElement(InternalAppErrorBoundary, null, children)))));
}
const StyledPageContent = styled.div`
  flex: 1;
  overflow-y: auto;
  height: 100%;
  background: ${props => pageBackgroundColor[props.background]};
`;

/**
 * We use a modified version of the link created by
 * next-router-provider where these attributes are optional.
 * This allows the end-user to skip using the router helpers and
 * just add onClick and href attributes manually if needed:
 *
 *     {
 *       link: {
 *         href: 'https://example.com
 *       }
 *     }
 *
 * While still allowing them to use the route helpers:
 *
 *     {
 *       link: createLink({
 *         pathname: '/accounts/[uuid]'
 *         query: {
 *           uuid: '1',
 *         }
 *       })
 *     }
 */

/**
 * Some of the components only support click handlers that don't pass through
 * the event handler, and thus are not compatible with the `onClick` returned by
 * `createLink`. For these cases, we use the `push` function instead.
 */
let TabIcon;

(function (TabIcon) {
  TabIcon["FILES"] = "FILES";
  TabIcon["BIND"] = "BIND";
  TabIcon["COMPARE"] = "COMPARE";
  TabIcon["FOLDER"] = "FOLDER";
  TabIcon["PLAN"] = "PLAN";
  TabIcon["PREPARE"] = "PREPARE";
  TabIcon["PROPOSE"] = "PROPOSE";
  TabIcon["SUBMIT"] = "SUBMIT";
})(TabIcon || (TabIcon = {}));

export { AppHeader as A, ErrorBoundaryWithMessages as E, InternalAppErrorBoundary as I, LayoutConfigProvider as L, PageLayout as P, TabIcon$1 as T, LinkType as a, AppType as b, bugsMessage as c, getAppTypeMetadata as g };
